/**
 *	@namespace PAL
 *	jsPAL object, contains the PAL javascript functions
 *  The global variable jsPAL in the main entry point into the PAL logic
 */
var jsPAL = new function()
{
	/**
	 * Set up the PALOperationsNode which is used by operations.js when
	 * deleting a row from a grid
	 */
	this.PALOperationsNode =
	{
		Name : 'PalOperationsNode',
		DoSubmit : submitGridNode,
		DoUpdate : submitGridNodeUpdate,
		DoSave : submitGridNodeSave,
		DoReset : submitGridNodeReset,
		DoRefresh : function()
		{
		},
		DoRefreshGrids : function()
		{
			jsPAL.refreshJQGrids();
		},
		GetErrorBox : function()
		{
			return null;
		},
		ReadOnly : false
	};
	/*
	* Used by notification window
	*/
	this.highlightTimer = 0;
	this.doNotificationHighlight = false;
	/**
	* PAL module name
	*/
	this.PALModuleName = 'Unknown';
	/**
	* PAL module caption
	*/
	this.PALModuleCaption = 'Unknown';
	/** 
	 * optional text to prefix to tab text
	 */
	this.tabTextPrefix = null;
	/**
	* number of specimens to add
	*/
	this.numSpecimensToAdd = 0;
	/**
	 * If true, the save all event has been fired but not consumed
	 */
	this.awaitingSaveAllForCompleteCaseEvent = false;
	/**
	 * The enumerations for the cExtendedSoapClients
	 */
	this.soapClientEnumerations =
	{
		Image : 1,
		Security : 2,
		SpectrumHealthcare : 3,
		Pal : 4,
		Amn : 5
	};
	/**
	 * Enumeration of all of the PalModule.Name in the database
	 * Please use the enumeration not the string when comparing values
	 */
	this.palModuleNames =
	{
		AllRecords			: "AllRecords",
		CaseAssembly		: "CaseAssembly",
		DigitalReview		: "DigitalReview",
		TumorBoard			: "TumorBoard",
		IntraOperative		: "IntraOperative",
		ConsultationReview	: "ConsultationReview",
		ConsultationRequest : "ConsultationRequest",
		HealthcareAdmin		: "HealthcareAdmin",
		AmnCaseAssemble		: "AmnCaseAssemble",
		AmnCaseUpload		: "AmnCaseUpload",
		AmnConsultRequest	: "AmnConsultRequest",
		AmnConsultAssign	: "AmnConsultAssign",
		AmnConsultReview	: "AmnConsultReview"
	};
	/**
	 * Enumeration of all of the CaseStates in the database
	 * Please use the enumeration not the string when comparing values
	 */
	this.caseStates =
	{
		InAssembly							: {
			id:1,
			name	:'InAssembly'
		},
		ReadyForReview						: {
			id:2,
			name	:'ReadyForReview'
		},
		AdditionalWorkNeeded				: {
			id:3,
			name	:'AdditionalWorkNeeded'
		},
		Completed							: {
			id:4,
			name	:'Completed'
		},
		AmendmentReadyForReview				: {
			id:5,
			name	:'AmendmentReadyForReview'
		},
		ConsultationRequestInProgress		: {
			id:6,
			name	:'ConsultationRequestInProgress'
		},
		ConsultationRequested				: {
			id:7,
			name	:'ConsultationRequested'
		},
		ConsultationCompleted				: {
			id:8,
			name	:'ConsultationCompleted'
		},
		IOCInAssembly						: {
			id:9,
			name	:'IOCInAssembly'
		},
		AdditionalAmendmentWorkNeeded		: {
			id:10,
			name	:'AdditionalAmendmentWorkNeeded'
		},
		IOCReadyForReview					: {
			id:11,
			name	:'IOCReadyForReview'
		},
		AdditionalIOCWorkNeeded				: {
			id:12,
			name	:'AdditionalIOCWorkNeeded'
		},
		IOCCompleted						: {
			id:13,
			name	:'IOCCompleted'
		},
		AmendmentCompleted					: {
			id:14,
			name	:'AmendmentCompleted'
		},
		ConsultationRequestInProgressAWN	: {
			id:15,
			name	:'ConsultationRequestInProgressAWN'
		},
		ConsultationRequestedAWN			: {
			id:16,
			name	:'ConsultationRequestedAWN'
		},
		ConsultationRequestRevoked			: {
			id:17,
			name	:'ConsultationRequestRevoked'
		},
		ConsultationRequestDeclined			: {
			id:18,
			name	:'ConsultationRequestDeclined'
		}
	};
	/**
	 * A list of columns that comes back with all of the GetXXXMethods
	 * The attributes are stored as attributes of the jQGrid <tr> elements
	 */
	this.workflowSharedColumns =
	{
		AssignedUserGroupId		: {
			attr :'AssignedUserGroupId',
			downto : 'AssignedUserGroupId'
		},
		AssignedUserId			: {
			attr :'AssignedUserId',
			downto : 'AssignedUserId'
		},
		AssignedUserFullName	: {
			attr :'AssignedUserFullName',
			downto : 'downtovwcaseinfobycaseid.assignedto'
		},
		AccessFlags				: {
			attr :'AccessFlags',
			downto : 'AccessFlags'
		}
	}
	/**
	 * Returns true if is AMN PALModule Name
	 */
	this.isAmnPALModule = function()
	{
		var moduleName = typeof moduleName !== 'undefined' ? moduleName : jsPAL.getPALModuleName();
		if (moduleName.match(/Amn/i))
		{
			return true;
		}
		return false;
	};
	/**
	 * The precision to use when displaying progress bar percentage
	 */
	this.progressBarPrecision = 0;
	/**
	 * Enumeration of the Values returned by the VwXXXX aggregate functions
	 * These are used in the rollup of the grid
	 * 12.21.12 - Updated to include additional statuses (not used yet) - ccb
	 */
	this.progressBarUploadStatusEnum =
	{
		FAILED	  : "FAILED",
		UPLOADING : "UPLOADING",
		QUEUED    : "QUEUED",
		FINISHED  : "FINISHED",
		RETRYING  : "RETRYING"
	};
    /**
     * get the currently active grid on the main tab page.
     * if there is a grid selector on the main page, then the selected grid is returned
     * else if there the first grid is returned
     * else return null
     */
    this.getActiveGrid = function()
    {
        var grids = $('.ui-jqgrid-btable').not('subgrid');
        var select = $('#gridSelect');
        if (select.length > 0 )
            return grids[select.find(":selected").index()];
        else if (grids.length > 0)
            return grids[0];
        return null;
    }
	/**
	 * Set the currently running PALModule Name 
	 * This matches the PALModule.Name SQL column
	 */	
	this.setPALModuleName = function(name)
	{
		this.PALModuleName = name;
	};
	/**
	 * Get the currently running PALModule Name 
	 * This matches the PALModule.Name SQL column
	 */
	this.getPALModuleName = function()
	{
		if (undefined === this.PALModuleName)
		{
			return 'Unknown';
		}
		return this.PALModuleName;
	};
	/**
	 * Get the current PAL Module DataServer Proxy
	 */
	this.getDataServerPalModuleProxy = function(moduleName)
	{
		moduleName = typeof moduleName !== 'undefined' ? moduleName : jsPAL.getPALModuleName();
		var dataServerClient = this.soapClientEnumerations.SpectrumHealthcare;
		if (moduleName.match(/Amn/i))
		{
			dataServerClient = this.soapClientEnumerations.Amn;
		}
		return dataServerClient ;
	};
	this.setPALModuleCaption = function(caption)
	{
		this.PALModuleCaption = caption;
	};
	this.getPALModuleCaption = function()
	{
		if (undefined === this.PALModuleCaption)
		{
			return 'Unknown';
		}
		return this.PALModuleCaption;
	};
	/**
	* window resize logic. the test for change in window height or window width is required for IE8,
	* because IE8 triggers many resize events even if the window has not resized, such as when an element in the
	* window has been resized. if those resize events are processed, we get into an infinite loop of resize events
	* being sent.
	*/
	this.prevWindowHeight = $(window).height();
	this.prevWindowWidth = $(window).width();
	$(window).on("resize.pal", function()
	{
		if (jsPAL.prevWindowHeight != $(window).height() || jsPAL.prevWindowWidth != $(window).width())
		{
			// resize jqGrids if window width has changed
			if (jsPAL.prevWindowWidth != $(window).width())
				jsPAL.resizeJQGrids();
			// reposition / resize the command bar
			jsPAL.cmdBar.reposition();
			// save previous window dimensions
			jsPAL.prevWindowHeight = $(window).height();
			jsPAL.prevWindowWidth = $(window).width();
		}
	});
	/**
	 * Changes the width all of the visible jqGrids to match their containing outer div width
	 */
	this.resizeJQGrids = function()
	{
		var grid = $('.ui-jqgrid-btable').filter(':visible');

    // jQuery selectors *always* return something. I suspect the desired behavior is actually
    // `if (grid.length > 0) { ... }` but don't want to risk breaking anything with this change. Technically, the `grid.each()`
    // function immediately following swallows the bug, so maybe the right answer is to just remove the `if` check.
		if (grid)
		{
			grid.each(function(index)
			{
				gridId = $(this).attr("id");
				if ($(this).hasClass('subgrid') !== true)
				{
					gridParentWidth = $("#gbox_" + gridId).parent().width();
				}
				else
				{
					// get subgrid's parent's width
					gridParentWidth = $('.ui-jqgrid').first().width() - $(this).closest('subgrid-cell').width();
				}
				if ($("#" + gridId).setGridWidth)
				{
					$("#" + gridId).setGridWidth(gridParentWidth);
				}
			});
		}
	};
	/** 
	 * Refresh all grids.  
	 * This generates another dataserver call for each grid on the page
	 */
	this.refreshJQGrids = function()
	{
		$(".ui-jqgrid-btable").trigger('reloadGrid');
	};
	/**
	 * Load a jqgrid with parameters passed in client side.
	 * This will set the cached grid filters in $_SESSION and fetch the data
	 * @param gridName The name of the view.  This matches DataView.Name sql column
	 * @param gridDivId The html id of the jqgrid
	 * @param FilterTables An array of tables to filter by
	 * @param FilterColumns An array of columns to filter by
	 * @param FilterOperators An array of filter operators
	 * @param FilterValues An array of filter values
	 * @param FilterValues2 An array of  second filter values used with range operator
	 * @param FilterDataGroupAccessLevel, If set, specifies the DataGroup access level filter, e.g. 'Full'
	 */
	this.LoadFilteredGrid = function(gridName, gridDivId, FilterTables, FilterColumns, FilterOperators, FilterValues, FilterValues2, FilterDataGroupAccessLevel)
	{
		// clear all errors on search form when loading 
		eraseErrors();
		// send the view filters to SetViewFilters.php
		var data = 'View=' + gridName;
		// these lengths should be all equal, but just to be sure, use the
		// minimum length
		var len = Math.min(FilterTables.length, FilterColumns.length, FilterOperators.length, FilterValues.length);
		for ( var i = 0; i < len; i++)
		{
			//  For searching values use encodeURIComponent to encode special charcters before passing it in URL parameters
			data += '&FilterTables[]=' + FilterTables[i] + '&FilterColumns[]=' + FilterColumns[i] + '&FilterOperators[]=' + FilterOperators[i] + '&FilterValues[]=' + encodeURIComponent(FilterValues[i]);
			// add FilterValues2 for filters with range opearator
			if (FilterValues2 != undefined)
			{
				if (FilterValues2[i] != null)
				{
					data +=  '&FilterValues2[]=' +encodeURIComponent(FilterValues2[i]);
				}
			}
		}
		if (undefined !== FilterDataGroupAccessLevel)
			data += '&FilterDataGroupAccessLevel=' + FilterDataGroupAccessLevel;
		Ajax(
		{
			type : 'POST',
			url : '/PALModules/HealthCare/SetViewFilters.php',
			data : data,
			success : function(msg)
			{
				var response = ParseJson(msg);
				if (response == null)
					return;
				if (response.Status == 'Success')
				{
					// reload the grid
					var grid = $('#' + gridDivId).find('.ui-jqgrid-btable');
					grid.trigger('reloadGrid',
					[
					{
						page : 1
					}]);
				}
				else
				{
					// invalid searching parameters were submited 
					// returns response.status as an array with the following format
					//{"Status":["Tablename.Fieldname-ErrorMessage","...."]}
					// parse response.status to bring  the errors to the form and highlight invalid search paramenters                
					var index =0;					
					for ( index=0; index < response.Status.length; index++)
					{ 					
						var str = response.Status[index];
						var FieldName = '';
						var TableName = '';
					
						if (str.indexOf("-") && str.indexOf("."))
						{
							FieldName = str.substring(str.indexOf(".")+1,str.indexOf("-"));
							TableName = str.substr(0,str.indexOf("."));
							// display an error div tag under each invalid search parameter inputs 
							var z = '<div id=shortError >' + str.substring(str.indexOf("-")+1) + '</div>'; 
							var thisdiv = $('#' + gridDivId).find(' table[name='+TableName+'] tr[name=' +FieldName+ ']');
							thisdiv.find("td").eq(1).append(z); 						
						}
						else
						{  	// Pop up an error if invalid search was performed or search invalid parameter were passed
							// this should never happen
							alert (response.Status);
						}
					}
					  
				}
			},
			error : function(jqXHR, textStatus, errorThrown)
			{
			}
		});
	};
	/*
	* returns an object with data from the contents of a table row
	* hdrCells is a jQuery containing <th>'s which is used to get the data column names 
	* @param colModel A jQuery grid's column model
	* @param rowCells A jQuery containing td's with the data values
	*/ 
	this.parseRow = function(colModel, rowCells)
	{
		// in case parms aren't a jQuery
		if (colModel instanceof jQuery === false)
		{
			colModel = $(colModel);
		}
		if (rowCells instanceof jQuery === false)
		{
			rowCells = $(rowCells);
		}
		var response = {};
		colModel.each(function(i)
		{
			// get the text from the <th>, may be embedded in a descendant,
			// e.g. <th><div><p>text</p></div></th>
			var hdrText = $(this)[0].name;
			if (hdrText !== '')
			{
				// get the text embedded in the <td>
				var dataText = rowCells.eq(i).find('*').last().html();
				if (dataText == '&nbsp;')
				{
					dataText = '';
				}
				else
				{
					dataText = jQuery.trim(dataText);
				}
				response[hdrText] = dataText;
			}
		});
		// return the object
		return response;
	};
	/**
	 * Creates the top level row of tabs
	 */
	this.makeTabs = function()
	{
		$('.PALTabDiv').each(function()
		{
			jsPAL.makeTabRow($(this));
///???ELLIS			jsPAL.selectTab($(this), 0);
		});
	};
	/**
	 * Create a tab row with caching enabled.
	 */
	this.makeTabRow = function(tabDiv)
	{
		tabDiv.tabs({
			// cache option no longer exists as of jQuery 1.9, stackoverflow says to do this:
			beforeLoad: function( event, ui ) {
				if ( ui.tab.data( 'loaded' ) ) {
					event.preventDefault();
					return;
				}

				ui.jqXHR.success(function() {
					ui.tab.data( 'loaded', true );
				});
			}
		});
	};
	
	/**
	 * Enable all html controls beneath [divId] 
	 * Used to enable/disable the save complete button, paginators, anything that needs 
	 * to be enabled/disabled client side according to "Locking Rules"
	 * 
	 * This function is fired after the following events:
	 *   The Tab is constructed for the first time
	 *   A Grid Complete event occurs 
	 *   A tab switch event
	 *   Lock/UnLock
	 * 
	 * @param divId The html Id of the div below which all controls are enabled/disabled
	 * @param enabled true/false If the contents underneath the div should be enabled/disabled		 
	 */
	this.performLockingTabLogic = function(divId, enabled)
	{
		var theDiv = $('#' + divId);
		// change the decorated buttons styles [eg save and complete]
		if (false === enabled)
		{
			// change jquery ui button classes
			theDiv.find('.ui-button').removeClass('ui-state-default')
				.addClass('ui-state-disabled')
				.attr('disabled', 'disabled');

			// change the jqgrid pagination controls
			theDiv.find(':input:not(.ui-pg-input, .ui-pg-selbox)').attr('disabled', true);
			
			// hide the Delete Image links
			theDiv.find('.thumbnailDelLink').css('display', 'none').html('');
		}
		else
		{
			// change jquery ui button classes, except for those that have the permanent_disable class
			theDiv.find('.ui-button:not(.permanent_disable)').removeClass('ui-state-disabled')
				.addClass('ui-state-default')
				.removeAttr('disabled');

			// change the jqgrid pagination controls
			theDiv.find(':input:not(.ui-pg-input, .ui-pg-selbox):not(.decorated_button)').attr('disabled', false);

			// for Case Assembly, show the Delete Image links
			if ('CaseAssembly' === jsPAL.getPALModuleName())
			{
				theDiv.find('.thumbnailDelLink').css('display', '').html('Delete Image');
			}
		}
		// foreach view underneath the common view page wrapper disable
		// any controls for views that have defaulteditable=false
		theDiv.find('div.ViewInformation').each(function()
		{			
			//disable all the html inputs too
			if (('false' === $(this).attr('defaulteditable')))
			{
				$(this).find('fieldset').find(':input').attr('disabled', true);
			}
			if (('false' === $(this).attr('canedit')))
			{
				$(this).find('.ui-button').removeClass('ui-state-default')
					.addClass('ui-state-disabled')
					.attr('disabled', 'disabled');				
			}
		});
		jsPAL.setLockedTabCssStyles(divId);

		// trigger event at end, so it has already done it's logic
		$(document).trigger('PALLockingTab', [divId, enabled]);
	};
	/**
	 * Construct a tab in a tab div
	 * 
	 * @param {type} tabDiv		- the containing tab div
	 * @param {type} tabId		- id of the tab panel div
	 * @param {type} index		- position to insert the tab in tabDiv
	 * @param {type} tabLabel	- text for the tab
	 * @param {type} tabContentHtml - content for the tab panel div
	 * @returns {undefined}
	 */
	this.createTab = function (tabDiv, tabId, index, tabLabel, tabContentHtml)
	{
		tabId = tabId.toString();
		if (tabId.substr(0, 0) == '#')
		{
			tabId = tabId.substr(1);
		}
		var header = "<li><a href='#" + tabId + "'>" + tabLabel + "</a></li>"
		var ul = tabDiv.find("ul").filter(":visible").filter(":first");
		if (ul.length == 0)
		{
			ul = $("<ul></ul>");
			tabDiv.append(ul);
		}
		var li = $(ul.find('li').filter(':visible'));
		// insert the list element into the ul
		if (li.length > 0 && index < li.length)
		{
			li.eq(index).before(header);
		}
		else
		{
			ul.append(header);
		}
		if ($('#' + tabId).length == 0)
		{
			tabDiv.append("<div id='" + tabId + "'></div>");
		}
		if (tabContentHtml != '')
		{
			$('#tabId').html(tabContentHtml);
		}
		tabDiv.tabs("refresh");
		this.selectTab(tabDiv, index);
	};

	/***
	 * 
	 * @param {type} tabDiv		- the containing tab div
	 * @param {type} URL		- URL used to load the tab via AJAX
	 * @param {type} tabLabel	- tab text
	 * @returns {undefined}
	 */
	this.createTabWithURL = function(tabDiv, URL, tabLabel)
	{
		$( "<li><a href='" + URL + "'>New Tab</a></li>" )
			.appendTo( tabDiv.find('ul') );
			tabDiv.tabs( "refresh" );
	};
	/**
	 * Adds a new tab the element defined in tabDiv
	 * The tabs are inserted into the AlreadyOpenedCases[] by their case Id
	 * @param tabDiv The html element for html
	 * @param tabText The text that appears in the tab's title
	 * @param index The index into the tabs() array
	 * @param showLockIcon True/False Show the lock icon
	 * @param showCloseIcon True/False Show the X icon	 
	 * @param permanentLock True/False If true, the tab can never be unlocked
	 */
	this.addNewTab = function(tabDiv, tabText, index, showLockIcon, showCloseIcon, permanentLock)
	{
		// ensure that the tbat is unique in the dom
		var id = Math.floor(Math.random() * 10000);
		this.createTab(tabDiv, id, index, tabText, '');

		if (showLockIcon)
		{
			var classes = "pointer ui-icon ui-icon-locked";
			if (permanentLock)
			{
				classes += " permanent-lock";
			}
			$('#' + tabDiv.attr('id')).children('ul').children('li[role=tab][aria-selected=true]').append('<a href="lockicon" class="tab-icon"><span class="' + classes + '"></span></a>').find('a[href=lockicon]').click(function()
			{
				var isCurrentlyLocked = $(this).children('span').hasClass('ui-icon-locked');
				var siblingAnchors = $(this).siblings('a[href!=lockicon][href!=closebutton][href!=\\#]');
				
				var notificationMsg = '';
				var caseTab = null;
				var iDeviceUnlockMsg = 'Unlock not permitted: Workflow does not support updates on an iDevice';	
				var worflowDoesntAllowUnlockMsg = 'Unlock not permitted: Workflow does not support updates';
				var readOnlyUnlockMsg = 'Unlock not permitted: You have read-only access to this Case';
				var priorCasesUnlockMsg = 'Unlock not permitted: Updates to Prior Cases not supported';
				//note: In a WF when you open a second case, and close the first editable case, 
				//and have the site option to not allow unlocking tabs this is the message you recieve as documented in FB-17153
				var multipleCasesOpenMsg = 'Unlock not permitted: There is already an unlocked Case Tab open';
				var numOpenedTabs = $('#' + tabDiv.attr('id')).children('ul').children('li').length;
				var numPermLockedCases = $(tabDiv).find('span.permanent-lock').length;
				
				
				//find the case in the already opened cases object 
				//determine if it can be unlocked or if it is read-only [from dataserver]
				if (siblingAnchors)
				{
					// there should only be one sibling anchor,
					// otherwise we can not know what to close
					if (1 === siblingAnchors.size())
					{
						var siblingAnchorId = siblingAnchors.attr('href');
						if (AlreadyOpenedCases)
						{
							// walk the AlreadyOpenedCases looking for
							// the id of the anchor
							// when found the
							// AlreadyOpenedCases[].mainTabRowIndex can							
							for ( var key in AlreadyOpenedCases)
							{
								var possibleCaseTab = AlreadyOpenedCases[key];
								var tabRowId = '#' + possibleCaseTab['childTabsDivId'];
								if (tabRowId === siblingAnchorId)
								{
									caseTab = possibleCaseTab;
								}
							}
						}
					}
				}

				if (isCurrentlyLocked)
				{
					//fall through messaging logic defined in FB17153  	
					//
					//IF WF = AC  and user trys to unlock tab THEN
					//  msg = Unlock not permitted: Workflow does not support updates
					//ELSEIF User trys to unlock a Prior Case tab
					//  msg = Unlock not permitted: Updates to Prior Cases not supported
					//ELSEIF User only has RO access and attempts to open locked tab  THEN
					//  msg = Unlock not permitted: You only he read-only access to this Case
					//ELSEIF already an unlocked tab open  THEN
					//  msg = Unlock not permitted: There is already an unlocked Case tab open
					//ELSEIF WF = CA and User trys to unlock tab THEN
					//  IF on iDevice THEN
					//      msg = Unlock not permitted: Workflow does not support updates on an iDevice
					//  ENDIF
					//ELSEIF Admin option doesn't support unlock AND user attempts to unlock THEN
					//  IF already unlocked tab open  THEN
					//      msg = Unlock not permitted: There is already an unlocked Case tab open
					//ELSE
					//  unlock permitted
					//ENDIF					
					
					var isPermanentLock = $(this).children('span').hasClass('permanent-lock');
					// if tab is permanently locked, can't unlock it
					if (isPermanentLock)
					{							
						var numUnlockedTabs = numOpenedTabs - numPermLockedCases;																
						if ('AllRecords'   === jsPAL.getPALModuleName())
						{
							notificationMsg = worflowDoesntAllowUnlockMsg;
						}												
						else if (jsPAL.isPriorCaseTabText(tabText))
						{
							notificationMsg = priorCasesUnlockMsg;
						}
						else if ("false" === caseTab['CanEdit'])
						{							
							notificationMsg = readOnlyUnlockMsg;
						}
						else if (numUnlockedTabs > 0)
						{
							if (true === SystemParms.isiDevice && 'CaseAssembly'  === jsPAL.getPALModuleName())
							{							
								notificationMsg = iDeviceUnlockMsg;
							}
							else
							{
								notificationMsg = multipleCasesOpenMsg;
							}
						}
						else if ('CaseAssembly'  === jsPAL.getPALModuleName())
						{
							if (true === SystemParms.isiDevice)
							{							
								notificationMsg = iDeviceUnlockMsg;
							}
							else
							{
								//generic CA fallthrough message [future workflows might will need to modify the conditions]
								notificationMsg = worflowDoesntAllowUnlockMsg;
							}
						}
						else
						{
							//generic fallthrough message [future workflows might will need to modify the conditions]
							notificationMsg = worflowDoesntAllowUnlockMsg;
						}
					}	
					else
					{	
						//the case is not permanently locked.  
						if (caseTab.accessflagsUnlockPermitted)
						{
							$(this).children('span').removeClass('ui-icon-locked');
							$(this).children('span').addClass('pointer ui-icon-unlocked');
							jsPAL.performLockingTabLogic(caseTab.childTabsDivId, true, false);
							AlreadyOpenedCases[key].isLocked = false;
						}
						else
						{
							notificationMsg = readOnlyUnlockMsg;
						}
					}
				}
				else
				{
					//tab is in the unlocked state..  always allow them to lock it
					$(this).children('span').removeClass('ui-icon-unlocked');
					$(this).children('span').addClass('ui-icon-locked');
					jsPAL.performLockingTabLogic(caseTab.childTabsDivId, false, false);
					AlreadyOpenedCases[key].isLocked = true;					
				}
				
				if (notificationMsg)
				{
					jsPAL.displayNotification(notificationMsg, 4);
				}
				// don't follow the link
				return false;
			});
		}

		if (showCloseIcon)
		{
			tabDiv.children('ul').children('li[aria-selected="true"]').append('<a href="closebutton" class="tab-icon"><span class="pointer ui-icon ui-icon-circle-close"></span></a>').find('a[href=closebutton]').click(function()
			{
				var siblingAnchors = $(this).siblings('a[href!=closebutton][href!=lockicon][href!=\\#]').filter(function()
				{
					return 0 === $(this).children('span.ui-icon-locked').size();
				});
				if (siblingAnchors)
				{
					if (1 === siblingAnchors.size())
					{
						var dataChangeWarningMessage = "Data on this page has been modified.  If you proceed without saving, these changes WILL BE LOST.\nIf you wish to save the changes please press CANCEL.";
						var resultCheckDataUnsaved = CheckDataUnsaved();
						if (resultCheckDataUnsaved)
						{
							// check to see if the returned is a string for the confirm message
							if (resultCheckDataUnsaved !== true)
							{
								dataChangeWarningMessage = resultCheckDataUnsaved;
							}
							if (!confirm(dataChangeWarningMessage))
							{
								//do not close the tab
								return false;
							}
						}
						
						var siblingAnchorId = siblingAnchors.attr('href');
						var $siblingAnchorId = $(siblingAnchorId);
						if (AlreadyOpenedCases)
						{
							// close any tabs that are contained within this tab and have a close button.
							// This cleans up AlreadyOpenedCases and removes any cLists for the case(s)
							// NOTE, this will recursively call this click() function.
							$siblingAnchorId.find('span.ui-icon-circle-close').click();

							// walk the AlreadyOpenedCases looking for
							// the id of the anchor
							// when found the
							// AlreadyOpenedCases[].mainTabRowIndex can
							// be used to remove the tab
							var tabObjectToDelete = null;
							for ( var key in AlreadyOpenedCases)
							{
								var caseTab = AlreadyOpenedCases[key];
								var tabRowId = '#' + caseTab['childTabsDivId'];
								// if this case is on this tab row 
								if (siblingAnchorId == tabRowId)
								{
									// remove any bound cList items from the
									// GlobalList
									$(tabRowId).find('div.ViewInformation').each(function()
									{
										GlobalList.RemoveList($(this).attr('CListName'));
									});
									// get the index of the tab who's close button was clicked
									var tabIndex = $(this).parent().index();
									if (tabIndex === caseTab.caseTabRowIndex || tabIndex === caseTab.mainTabRowIndex)
									{
										tabObjectToDelete = key;
											tabDiv.find('li').eq(tabIndex).remove();
											jsPAL.selectTab(tabDiv, tabIndex - 1);
											break;
									}
								}
							}
							if (tabObjectToDelete)
							{
								// when the tab is removed from the list
								// all of the selected indicies are
								// decremented by one
								var tabRowProperty = ((undefined !== AlreadyOpenedCases[tabObjectToDelete].caseTabRowIndex) ? "caseTabRowIndex" : "mainTabRowIndex");
								var deletedIndex = AlreadyOpenedCases[tabObjectToDelete][tabRowProperty];

								for ( var keyDelete in AlreadyOpenedCases)
								{
									var decrementCaseTab = AlreadyOpenedCases[keyDelete];

									if (decrementCaseTab[tabRowProperty] > deletedIndex)
									{
										AlreadyOpenedCases[keyDelete][tabRowProperty] = AlreadyOpenedCases[keyDelete][tabRowProperty] - 1;
									}
								}
								delete AlreadyOpenedCases[tabObjectToDelete];

								// if case can be unlocked, remove permanent-lock class from the case tab								
								var selectedTabIndex = jsPAL.getSelectedTabIndex(tabDiv);
								var selectedTabText = jsPAL.getSelectedTabText(tabDiv);
								//The workflow tab counts as one of the opened tabs
								var numOpenedTabs = $('#' + tabDiv.attr('id')).children('ul').children('li').length - 1;
								var numPermLockedCases = $(tabDiv).find('span.permanent-lock').length;
								var numUnlockedTabs = numOpenedTabs - numPermLockedCases;																
								if (numOpenedTabs >= 0)
								{
									for ( var key2 in AlreadyOpenedCases)
									{
										var findOpenedCaseInfo = AlreadyOpenedCases[key2];	
										if (selectedTabIndex === findOpenedCaseInfo["mainTabRowIndex"] )
										{
											var canUnlock = true;
											// test for conditions where tabs can not be unlocked
											if (
												// can't unlock All Records
												('AllRecords' === jsPAL.getPALModuleName()) ||
												// can't unlock Case Assembly on iPad / iPhone
												(true === SystemParms.isiDevice && 'CaseAssembly' === jsPAL.getPALModuleName()) || 
												// can't unlock Readonly case
												("false" === findOpenedCaseInfo["canEdit"]) ||
												// can't unlock prior cases
												(jsPAL.isPriorCaseTabText(selectedTabText)) ||
												// can't unlock if more than one tab open unless system option is set
												// NOTE WorkflowAllowUnlock is being removed from the R12 UI, so there is no way
												// to set it. The code is left in place, in case WorkflowAllowUnlock is added back to the 
												// UI in a future release.
												(numUnlockedTabs > 0 && (numPermLockedCases > 1 && false === SystemParms.WorkflowAllowUnlock)) )
												{
													canUnlock = false;
												}
											if (canUnlock)
												$($(tabDiv).find('span.permanent-lock')[0]).removeClass('permanent-lock');
										}
									}
								}
							}
						}
					}
				}
				// Housekeeping: remove the 'case tab div' (and it's contents) that is being closed
				$siblingAnchorId.remove();
				$(document).trigger('PALTabClosedEvent');
				// don't follow the link
				return false;
			});
		}
		return id;
	};
	/**
	 * Styling a modal dialog so that the controls have the same height
	 * @param ModalDialogId The HTML id of modal dialog
	 */
	this.dynamicHtmlModalLayout = function(ModalDialogId)
	{
		var dlg = $(ModalDialogId);
		var maxInputHeight = -99;
		$(dlg).find(':input').each(function()
		{
			if ($(this).height() > maxInputHeight)
			{
				maxInputHeight = $(this).width();
			}
		});
		//loop over all of the inputs again and
		//set their height equal to the tallest in the set
		$(dlg).find(':input').each(function()
		{
			if ($(this).height() < maxInputHeight)
			{
				$(this).height(maxInputHeight);
			}
		});
	};
	/**
	 * gets text and default caption text for a case tab, uses synchronous AJAX
	 * @param caseId The case id
	 */
	this.getCaseTabText = function(caseId)
	{
		var tabText = '';
		var defaultCaptionText = {};
		$.ajax({
			type: "GET",
			url: "/GetRecordCaptionText.php",
			async: false,
			data: "AJAX=true&TableName=Case&RecordId=" + caseId,
			success: function(response)
			{
				response = eval('(' + response + ')');
				tabText = response.CaptionText;
				if (undefined === tabText)
		{
					tabText = 'Case ' + caseId;
				}
				var prefix = jsPAL.getTabTextPrefix();
				if (prefix !== '')
		{
					tabText = prefix + ' | ' + tabText;
				}
				if (undefined !== response.DefaultCaptionText)
		{
					defaultCaptionText = response.DefaultCaptionText;
				}
				//clear any tab prefix that might have been set [e.g. Prior Case]
				jsPAL.clearTabTextPrefix();
			}
		});
		return {tabText : tabText, defaultCaptionText : defaultCaptionText};
	};
	/**
	 * Formats the output of a common view display page content:
	 *   Aligns labels
	 *   Sets the width of the input/label pair to match the width of the containing div
	 *   Applies DatePicker Styles		 *   
	 * @param ViewWrapperId The HTML id of the containing a common view display generated content
	 */
	this.dynamicHtmlElementLayout = function(ViewWrapperId)
	{
		$('.DatePicker').datepicker(
		{
			dateFormat : SystemParms.DatePickerFormat
		});
		$('.DateWatermark').watermark(SystemParms.DateFormatHint);
		$('.DateTimePicker').datetimepicker(
		{
			dateFormat : SystemParms.DatePickerFormat
		});
		$('.DateTimeWatermark').watermark(SystemParms.DateFormatHint + ' hh:mm');
		$('.TimeWatermark').watermark('hh:mm:ss');
		// dynamically style all views to fit into their containing div
		// the :visible selector prevents this code from modifying fieldsets
		// on other
		$('#' + ViewWrapperId).find('fieldset:visible.ViewDisplay div').each(function()
		{
			// var columnDivWidth = $(this).outerWidth();
			var maxLabelWidth = -99;
			$(this).children().find('label.ViewDisplay').each(function()
			{
				if ($(this).width() > maxLabelWidth)
				{
					maxLabelWidth = $(this).width();
				}
			});
			var maxInputWidth = -99;
			$(this).children().find(':input.ViewDisplay').each(function()
			{
				if ($(this).width() > maxInputWidth)
				{
					maxInputWidth = $(this).width();
				}
			});
			$(this).children().find('label.ViewDisplay').css('display', 'inline-block');
			$(this).children().find('label.ViewDisplay span').css('display', 'inline-block');
			$(this).children().find('label.ViewDisplay').css('width', maxLabelWidth);
		});

		// remove anything that have has decorated for a view when the view
		// does not have any data.
		// for example: Remove the save and complete button from the Digital
		// Review Ammended Results Entry when there are no ammended results
		// display.php outputs an empty <div class="NoDataInView"> when
		// there were no records found in a view
		$('#' + ViewWrapperId).find('.NoDataInView').parent('div.ViewInformation').children().each(function()
		{
			$(this).remove();
		});
	};
	
	/**
	* grid column model cache used by isColumHiddenInGrid()
	*/
	this.colModelCache = 
				{'Case' : null,
				 'Specimen' : null,
				 'Slide' : null};
	
	/**
	* function to determine if a particular column is hidden in the grid for the table	
	* first, the visible main grid is searched for the column. If it is not found in the main
	* grid, then the subgrids are searched for the column.		
	*/
	this.isColumnHiddenInGrid = function(colName, tableName)
	{
		var hidden = false;
		var grid = null;
		var tmpCol = colName;
		var tmpTbl = tableName;

		// remap some column and table names.
		switch (tmpTbl)
		{
			case 'Case':
				switch (tmpCol)
				{
					case 'PatientFirstName':
					case 'PatientName':
						tmpCol = 'PatientFullName';
						break;
					case 'DownToCaseReviewResultByCaseId.ResultText':
						tmpCol = 'DownToVwCaseResultsByCaseId.FinalResult';
						break;
					case 'DownToCaseReviewResultByCaseId.AuthorName':
						tmpCol = 'DownToVwCaseInfoByCaseId.AssignedTo';
						break;
				}
				break;
			case 'CaseReviewResult':
				switch(tmpCol)
				{
					case 'ResultText':
						tmpCol = 'DownToVwCaseResultsByCaseId.FinalResult';
						break;
				}
				break;
			case 'BodySite':
				switch (tmpCol)
				{
					case 'Name':
						tmpCol = 'DownToVwCaseAggregatesByCaseId.SpecimenBodySite';
						tmpTbl = 'Case';
						break;
				}
				break;
			case 'Specimen':
				switch (tmpCol)
				{
					case 'Procedure':
						tmpCol = 'DownToVwCaseAggregatesByCaseId.SpecimenProcedure';
						tmpTbl = 'Case';
						break;
					case 'ReceivedDate':
						tmpCol = 'DownToVwCaseAggregatesByCaseId.SpecimenReceivedDate';
						tmpTbl = 'Case';
				}
				break;
		}
		// try to find the column in the MainGrid
        grid = $(jsPAL.getActiveGrid());
		// Didn't find the column in the main grid. Try the subgrids
		// Note, if the subgrid hasn't been opened yet, this loop will
		// not find it because it doesn't yet exist.
		if (grid == null)
		{
			tmpCol = colName;
			tmlTbl = tableName;
			$(document).find('.subgrid.tablegrid').each(function()
			{
				// find the grid for this tmpTbl
				if ($(this).attr('tablename') == tmpTbl)
				{
					grid = $(this);
					// stop the .each loop by returning false
					return false;
			}
			});
		}

		if (grid !== null)
			{
			var colProp = grid.getColProp(tmpCol);
			if (isset(colProp.hidden))
				{
				hidden = colProp.hidden;
			}
		}
		return hidden;
	}
	/**
	* Show / Hide tab fields based on their visibility in the main grid
	*/
	this.ShowHideTabFields = function(panel)	
	{
		// ExtraReadonlyInfo is for readonly workflows, such as All Cases
		$(panel).find('span.ExtraReadOnlyInfo').each(function(){
			if (jsPAL.isColumnHiddenInGrid($(this).attr('columnname'), $(this).attr('tablename')) == true)
				$(this).hide();
			else
				$(this).show();
		});
		// .ViewDisplay is for editable workflows, such as Case Assembly
		$(panel).find('input.ViewDisplay,textarea.ViewDisplay').each(function(){
			if (jsPAL.isColumnHiddenInGrid($(this).attr('columnname'), $(this).attr('tablename')) == true)
			{
				// if it's not already disabled
				if ($(this).is(':disabled') === false)
				{
					// remember that it was disabled by this function
					$(this).attr('ShowHideTabFieldsDisabled', true);
					// save the current text in 'oldvalue' if it's not already there
					if ($(this).attr('oldvalue') == '')
					{
						$(this).attr('oldvalue', $(this).val());
					}
					// remove the text and disable the input
					$(this).val('');
					$(this).attr('disabled', 'disabled');
				}
			}
			else
			{
				// if it was disabled by this function, reenable it
				if ($(this).attr('ShowHideTabFieldsDisabled') === 'true')
				{
					// restore the text and enable the input
					$(this).val($(this).attr('oldvalue'));
					$(this).removeAttr('disabled');
					$(this).removeAttr('ShowHideTabFieldsDisabled');
				}
			}
		});
		
		// case grids
		$(panel).find('.tablegrid[tablename="Case"]').filter(':visible').each(function(){
			var grid = $(this);
			var colModel = grid.jqGrid ('getGridParam', 'colModel');
			if (colModel)
			{
				var len = colModel.length;
				for (var i = 0; i < len; i++)
				{
					var hidden = jsPAL.isColumnHiddenInGrid(colModel[i].name, 'Case');
					grid.jqGrid(hidden ? 'hideCol' : 'showCol', colModel[i].name);
				}
			}
		});

	}
	/**
	* Add button to open WebViewer
	*/

	this.AddWebViewerButton = function(caseId, ui)   
    {
        const workflowId = ui.panel.context.id;
        const $caseTabBar = $("#" + workflowId + " ul.ui-tabs-nav").last();
        const $tabPanelButton = $caseTabBar.find("li#tabPanelButton" + caseId);
        if (!$tabPanelButton.length) {
			$caseTabBar.append(
				$('<li>', { class: 'tabPanelButton',
					id: 'tabPanelButton' + caseId }).append(
					$('<a>', {
					target: 'WebViewer',
					title: 'Launch WebViewer',
					href: '/eSlideTray.php?TableName=Case&Id=' + caseId
				}).append(
					"<svg class='icon svgicon'><use xlink:href='/Images/icons.svg#eye_s'></use></svg><span>eSlides</span>"
				)
			)
		)}
	}

	/**
	 * Adds styles that can be used to style a tab that has been locked
	 * Adds css class LockedTab to the tab element
	 * Adds css class LockedContent to all elments beneath the tab
	 * @param ViewWrapperId The HTML id of the containing a common view display generated content
	 */
	this.setLockedTabCssStyles = function(ViewWrapperId)
	{
		// set the newly created tabs style to the locked style
		$('#' + ViewWrapperId).parent('div.ui-tabs-panel:first').siblings('ul.ui-tabs-nav:first').find('li').addClass('LockedTab');
		// set the tabs locked contents style
		$('#' + ViewWrapperId).find('*').not('.ui-tabs').addClass('LockedContent');

		// put the locked content class on everything beneath the tab
		$('#' + ViewWrapperId).find('*').not('ul.ui-tabs-nav').not('li').not('a').addClass('LockedContent');
		// change the tab rows classes
		$('#' + ViewWrapperId).find('ul.ui-tabs-nav li').addClass('LockedTab');
	};
	/**
	 * Foreach view underneath the common view page wrapper disable any controls when the user agent is iDevice 
	 *    AND the workflow is CaseAssembly or AllRecords
	 * @param ViewWrapperId The HTML id of the containing a common view display generated content
	 * @param enabled true/false If the contents underneath the div should be enabled/disabled		 
	 */
	this.workflowSpecificLockingTabLogic = function(ViewWrapperId, enabled)
	{		
		$('#' + ViewWrapperId).find('div.ViewInformation').each(function()
		{			
			// Workflow specific logic for locking tabs just for iPad
			if ((true === SystemParms.isiDevice))
			{
				// alert('I am an iDevice, and I operate in ReadOnly Mode...');
				if ((-1 !== $(this).attr("name").indexOf("CaseAssembly")) || (-1 !== $(this).attr("name").indexOf("AllRecords")))
				{
					// remove the New Specimen+ tab when in iDevice and CA
					// or AR
					// remove the Delete/UnAssign Tasks when in iDevice and
					// CA or AR
					$('li.newSpecimenTab').remove();
					$(this).find('span.iconlist a.Delete').remove();
					$(this).find('span.iconlist a.Unassign').remove();
					$(this).find('span.iconlist a.Assign').remove();
					jsPAL.performLockingTabLogic(ViewWrapperId, false, false);
				}
			}
			
			// If the current tab is not enabled remove:
			//    IF Case Assembly
			//         The trash can
			//         Assign
			//         Unassign
			//         New Specimen Link
			if (!enabled)
			{
				$('li.newSpecimenTab').remove();
				$(this).find('span.iconlist a.Delete').remove();
				$(this).find('span.iconlist a.Unassign').remove();
				$(this).find('span.iconlist a.Assign').remove();
				jsPAL.performLockingTabLogic(ViewWrapperId, false, false);
			}
		});
	};
	/**
	 * Get row level locking rules for creating the tabs
	 * This function is used when creating the tabs for the first tab [when clicking on a grid row]
	 * @param jqueryGridRow The jQuery Grid that has just been clicked.  
	 *                      When called from Free Text Search header the jqueryGridRow is undefined so the defaults are used
	 * @param mainTabRowElement The html element of the main tab row [MainTabs]
	 * @param workflowName The name of the workflow constructing the tabs
	 * @returns {isLocked: bool,  permanentlock: bool, tabIndexCount: int}
	 */
	this.getRowLevelConstructionLockingRules = function(jqueryGridRow, mainTabRowElement, workflowName)
	{
		// the default locking state
		var lockRules =
		{
			isLocked : false,
			permanentlock : false,
			tabIndexCount :  $('#' + $('#' + mainTabRowElement).attr('id')).children('ul').children('li').size()
		};
		if (jqueryGridRow)
		{
			var canEdit = jqueryGridRow.attr('canedit');
			var accessFlags = jqueryGridRow.attr('accessflags');
			if (canEdit && accessFlags)
			{
				canEdit = canEdit.toString().toLowerCase();
				accessFlags = accessFlags.toString().toLowerCase();
				if (('false' === canEdit) || ('full' !== accessFlags))
				{
					lockRules.isLocked = true;
				}
				// only full access things can ever unlock tabs
				if (('full' !== accessFlags.toString()))
				{
					lockRules.permanentlock = true;
				}
			}
		}
		// Workflow specific tab creation logic
		if ((true === SystemParms.isiDevice))
		{
			// alert('I am an iDevice, and I operate in ReadOnly Mode');			
			if (("CaseAssembly" === workflowName) || ("AllRecords" === workflowName))
			{
				lockRules.isLocked = true;
				lockRules.permanentlock = true;				
			}
		}
		// number of open tabs minus tab zero (the grid tab)
		var tabCount = lockRules.tabIndexCount - 1;
		// don't count the +New Case tab
		if (jsPAL.getTabIndexByText($('#' + mainTabRowElement), '+New Case') !== -1)
		{
			--tabCount;
			--lockRules.tabIndexCount;
		}
		// don't count the Search Tab
		if (jsPAL.getTabIndexByText($('#' + mainTabRowElement), 'Search') !== -1)
		{
			--tabCount;
		}				
		// if the number of case tabs open in any workflow (excluding the Grid tab, the Search tab and the +New Case tab) is greater than 0,
		// then set the new tab to be created locked
		lockRules.isLocked = lockRules.isLocked || (tabCount > 0 ? true : false);

		return lockRules;
	};
	/**
	 * Decrement the badge count, left hand sidebar, when a case has been opened from the grid row
	 * This is fired after the tabssload() event generated from the cWorkflowbuilder::LoadTabsFromGridSelectEvent() 
	 * @param caseId The caseUd
	 */
	this.decrementBadgeCountWhenOpeningCase = function(caseId)
	{
		// decrement the badge count for this Case
		Ajax(
		{
			type : "POST",
			url : "/PALModules/HealthCare/ResetCaseNotification.php",
			data : "caseid=" + caseId + "&palmodulename=" + jsPAL.getPALModuleName(),
			success : function(jsonData)
            {
                if (AlreadyOpenedCases != undefined) {
                    AlreadyOpenedCases[caseId].unviewed = false;
                }
				// get div for grid tab
				var div = jsPAL.getTabPanelDiv($('#MainTabs'), 0);
				// get the case grid
				var grid = div.find('.tablegrid[tablename=Case]');
				if (grid.length > 0)
				{
					var row = grid.find('.jqgrow[id=' + caseId + ']');
					// remove unviewed class from each td in the grid row
					// for the case, so the row is not displayed with bold
					// text
					row.find('*').removeClass('unviewed');
					// remove unviewed attribute from the row
					row.removeAttr('unviewed');
				}
				jsPAL.closeNotification();
			},
			error : function(jqXHR, textStatus, errorThrown)
			{
			}
		});
	};
	this.renameResultDescriptionGridsEventSHC = function(grid)
	{
		// if DataView.Name is of the form _Results_Grid_Case
		if ($(grid).attr('id').indexOf('_Results_Grid_Case') != -1)
		{
			$('.ui-jqgrid-bdiv div[tablename="Case"][columnname="DownToCaseReviewResultByCaseId\.UpToCaseStateByStateId\.Name"]').each(function(index)
			{
				var caseStateName = $(this).text();
				var reviewedByUserId = $(this).parent('div').parent('td').parent('tr').attr('downtocasereviewresultbycaseid\.reviewedbyuserid');
				//TODO: The results "Type" column in the grid needs to be renamed for AMN consultation states
				//      This is not very well defined in the SDD -- it says 'prellminary intrepreation', 'ammended intrepretation'

				if (undefined !== reviewedByUserId)
				{
					// Change these label variables to update all case states
				var amendedLabel = 'Amended (pending)';
				var amendedCompletedLabel = 'Amended';
				var internalConsultLabel = 'Internal Collaboration (pending)';
				var externalConsultLabel = 'External Collaboration (pending)';
				var internalConsultCompletedLabel = 'Internal Collaboration';
				var externalConsultCompletedLabel = 'External Collaboration';
				var caseReviewLabel = 'Case Review (pending)';
				var caseReviewCompletedLabel = 'Case Review';

				// choose each of the 14 possible case states and change
				// their labels
				switch (caseStateName)
				{
						case jsPAL.caseStates.InAssembly.name :
						$(this).text(caseReviewLabel);
						break;
						case jsPAL.caseStates.ReadyForReview.name :
						$(this).text(caseReviewLabel);
						break;
						case jsPAL.caseStates.AdditionalWorkNeeded.name :
						$(this).text(caseReviewLabel);
						break;
						case jsPAL.caseStates.Completed.name :
						$(this).text(caseReviewCompletedLabel);
						break;
						case jsPAL.caseStates.AmendmentReadyForReview.name :
						$(this).text(amendedLabel);
						break;
						case jsPAL.caseStates.ConsultationRequestInProgress.name :
						if (!reviewedByUserId)
						{
							$(this).text(externalConsultLabel);
						}
						else
						{
							$(this).text(internalConsultLabel);
						}
						break;
						case jsPAL.caseStates.ConsultationRequested.name :
						if (!reviewedByUserId)
						{
							$(this).text(externalConsultLabel);
						}
						else
						{
							$(this).text(internalConsultLabel);
						}
						break;
						case jsPAL.caseStates.ConsultationCompleted.name :
						if (!reviewedByUserId)
						{
							$(this).text(externalConsultCompletedLabel);
						}
						else
						{
							$(this).text(internalConsultCompletedLabel);
						}
						break;
						case jsPAL.caseStates.AdditionalAmendmentWorkNeeded.name :
						$(this).text(amendedLabel);
						break;
						case jsPAL.caseStates.AmendmentCompleted.name :
						$(this).text(amendedCompletedLabel);
						break;
					default :
						// unknown/new case state; do not change the text
						break;
				}
				}
			});
		}
	};
	/**
	 * Replace the Results Grids with custom named labels.
	 * @param grid  The jQgrid object that just finished loading its contents
	 */
	this.renameResultDescriptionGridsEventAmn = function(grid)
	{
		// if DataView.Name is of the form _Results_Grid_Case
		if ($(grid).attr('id').indexOf('_Results_Grid_Case') != -1)
		{
			$('.ui-jqgrid-bdiv div[tablename="Case"][columnname="DownToCaseReviewResultByCaseId\.UpToCaseStateByStateId\.Name"]').each(function(index)
			{
				var caseStateName = $(this).text();
				var consultRequestId = $(this).parent('div').parent('td').parent('tr').attr('downtocasereviewresultbycaseid\.consultrequestid');
				var reviewedByUserId = $(this).parent('div').parent('td').parent('tr').attr('downtocasereviewresultbycaseid\.reviewedbyuserid');

				if ("" !== reviewedByUserId)
				{
					// Change these label variables to update all case states
					if ("" === consultRequestId)
					{
						var preliminaryLabel		= 'Preliminary';
						var finalLabel				= 'Final';
						var amendedLabel			= 'Amended';
						switch (caseStateName)
						{
							case jsPAL.caseStates.ReadyForReview.name :
								$(this).text(preliminaryLabel);
								break;
							case jsPAL.caseStates.AdditionalWorkNeeded.name :
								$(this).text(preliminaryLabel);
								break;
							case jsPAL.caseStates.Completed.name :
								$(this).text(finalLabel);
								break;
							case jsPAL.caseStates.AmendmentReadyForReview.name :
								$(this).text(preliminaryLabel);
								break;
							case jsPAL.caseStates.AdditionalAmendmentWorkNeeded.name :
								$(this).text(preliminaryLabel);
								break;
							case jsPAL.caseStates.AmendmentCompleted.name :
								$(this).text(amendedLabel);
								break;
							default :
								// unknown/new case state; do not change the text
								break;
						}
					}
					else
					{
						var consultPreliminaryLabel = 'Preliminary Collaboration';
						var consultFinalLabel		= 'Final Collaboration';
						var consultRevokedLabel		= 'Revoked Collaboration';
						var consultDeclinedLabel	= 'Declined Collaboration';

						switch (caseStateName)
						{
							case jsPAL.caseStates.ConsultationRequested.name :
								$(this).text(consultPreliminaryLabel);
								break;
							case jsPAL.caseStates.ConsultationRequestedAWN.name :
								$(this).text(consultPreliminaryLabel);
								break;
							case jsPAL.caseStates.ConsultationCompleted.name :
								$(this).text(consultFinalLabel);
								break;
							case jsPAL.caseStates.ConsultationRequestRevoked.name :
								$(this).text(consultRevokedLabel);
								break;
							case jsPAL.caseStates.ConsultationRequestDeclined.name :
								$(this).text(consultDeclinedLabel);
								break;
							default :
								// unknown/new case state; do not change the text
								break;
						}
					}
				}
			});
		}
	}
	/**
	* Replace the Results Grids with custom named labels.
	* Key off of CaseState.Name to perform the custom result labels
	* Make sure to only bind the event once, because the loop is doing a foreach() over all of the grids
	* Fired from the GridCompleteEvent
	* @param event The javascript event
	* @param grid  The jQgrid object that just finished loading its contents
	*/
	this.renameResultDescriptionGridsEvent = function(event, grid)
	{
		if (jsPAL.soapClientEnumerations.Amn === jsPAL.getDataServerPalModuleProxy())
		{
			jsPAL.renameResultDescriptionGridsEventAmn(grid);
		}
		else
		{
			jsPAL.renameResultDescriptionGridsEventSHC(grid);
		}
	};
	/**
	 * Removes the tab and it's contents (div)
	 * @param tabIndex - the index of the tab to be deleted
	 */
	this.removeTab =  function(tabIndex) {
		var wrapperDiv = $('#MainTabs');
		var tab = wrapperDiv.find('.ui-tabs-nav li:eq(' + tabIndex + ')');
		var tabContentDiv = this.getTabPanelDiv(wrapperDiv, tabIndex);
		tabContentDiv.remove();
		tab.remove();
		wrapperDiv.tabs('refresh');
	}
	/**
	/**
	 * Receives the free text search from the search on the masthead
	 * @param searchString The search string entered by the user
	 * @param  searchOnlyCurrentWorkflow True/False.  If true, only the current workflow is searched
	 */
	this.ajaxFreeTextSearch = function(searchString, searchOnlyCurrentWorkflow)
	{
		// close any existing search tabs
		if (AlreadyOpenedCases)
		{
			// walk the AlreadyOpenedCases looking for a search result tab
			// when found the AlreadyOpenedCases[].mainTabRowIndex can be
			// used to remove the tab
			var tabObjectToDelete = null;
			for ( var key in AlreadyOpenedCases)
			{
				var tab = AlreadyOpenedCases[key];
				if (tab.isSearchTab)
				{
					tabObjectToDelete = key;
					this.removeTab(tab.mainTabRowIndex);
					break;
				}
			}
			if (tabObjectToDelete)
			{
				// when the tab is removed from the list all of the selected
				// indicies are decremented by one
				var deletedIndex = AlreadyOpenedCases[tabObjectToDelete].mainTabRowIndex;
				for ( var deletedKey in AlreadyOpenedCases)
				{
					var decrementCaseTab = AlreadyOpenedCases[deletedKey];
					if (decrementCaseTab.mainTabRowIndex > deletedIndex)
					{
						AlreadyOpenedCases[deletedKey].mainTabRowIndex = AlreadyOpenedCases[deletedKey].mainTabRowIndex - 1;
					}
				}
				delete AlreadyOpenedCases[tabObjectToDelete];
			}
		}
		// close +New Case tab
		if (typeof(closeNewCaseTab) === 'function')
		{
			closeNewCaseTab();
		}
		jsPAL.closeTabByText($('#MainTabs'), 'Search');
		var tabIndexCount = $('#MainTabs').children('ul').children('li').size();

		// add the new search result tab
		var searchContentId = jsPAL.addNewTab($('#MainTabs'), 'Search', tabIndexCount, false, true, false);
		jsPAL.getTabsForDiv($('#MainTabs')).eq(tabIndexCount).addClass('searchtab');
		AlreadyOpenedCases[searchString] =
		{
			isSearchTab : true,
			caseId : undefined,
			childTabsDivId : searchContentId,
			mainTabRowIndex : tabIndexCount,
			mainTabRowId : 'MainTabs'
		};

		var searchWorkflowParm = "";
		if (searchOnlyCurrentWorkflow)
		{
			searchWorkflowParm = "&SearchOnlyCurrentWorkflow=true";
		}
		else
		{
			searchWorkflowParm = "&SearchOnlyCurrentWorkflow=false";
		}

		Ajax(
		{
			type : 'POST',
			url : "/FreeTextSearch.php?NewSearch=true&SearchText=" + searchString + "&SearchResponseFormat=EMBEDDED" + searchWorkflowParm,
			dataType : 'html'
		}).success(function(jqXHR, textStatus, errorThrown)
		{
			$('#' + searchContentId).append(jqXHR);
		}).error(function(jqXHR, textStatus, errorThrown)
		{
			alert (errorThrown);
		});
	};
	/**
	 * Get all the children tabs of tabDiv
	 * @param tabDiv The html object to search beneath
	 * @return A list of tab elements
	 */
	this.getTabsForDiv = function(tabDiv)
	{
		return tabDiv.find('ul.ui-tabs-nav').first().children('li');
	};
	/**
	 * Close a tab by its index into the tab array
	 * @param tabDiv The html object to search beneath
	 * @param index The index of the tab into the tab array
	 */	
	this.closeTabByIndex = function(tabDiv, index)
	{
		tabDiv.find('li').eq(index).remove();
	};
	/**
	 * Get the index of the currently selected tab
	 * @param tabDiv The html object to search beneath
	 * @returns The index into the tab array
	 */	
	this.getSelectedTabIndex = function(tabDiv)
	{
		var index = -1;
		var tabs = this.getTabsForDiv(tabDiv);
		// if there is a tab with the specified id, close that tab
		tabs.each(function(i)
		{
			if (tabs.eq(i).hasClass('ui-state-active'))
			{
				index = i;
				return false; // break out of the .each function
			}
			return true;
		});
		return index;
	};
	/**
	 * Get the currently selected tab  
	 * @param tabDiv The tab container to search
	 * @returns The currently selected tab
	 */
	this.getSelectedTab = function(tabDiv)
	{
		return this.getTabsForDiv(tabDiv).eq(this.getSelectedTabIndex(tabDiv));
	};
	/**
	 * Get the currently selected tab by the text label
	 * @param tabDiv The tab container to search
	 * @param text The text displayed on the tab
	 * @returns The currently selected tab index or -1 if not found
	 */
	this.getTabIndexByText = function(tabDiv, text)
	{
		var index = -1;
		var tabs = this.getTabsForDiv(tabDiv);
		tabs.each(function(i)
		{
			if (tabs.eq(i).children('a').first().text() == text)
			{
				index = i;
				// break out of the .each function
				return false; 
			}
			return true;
		});
		return index;
	};
	/**
	 * Get a tab's text by the index into the tabs array
	 * @param tabDiv The tab container to search
	 * @param index The index into the tab array
	 * @returns The text on the tab
	 */	
	this.getTabTextByIndex = function(tabDiv, index)
	{
		var tabs = this.getTabsForDiv(tabDiv);
		return tabs.eq(index).children('a').first().text();
	};
	/**
	 * Get the currently selected tab's text 
	 * @param tabDiv The tab container to search	 
	 * @returns The text on the tab
	 */		
	this.getSelectedTabText = function(tabDiv)
	{
		var index = this.getSelectedTabIndex(tabDiv);
		return this.getTabTextByIndex(tabDiv, index);
	};
	/**
	 * Get a tabs index by html anchor id
	 * @param tabDiv The tab container to search	 
	 * @param id The id of the html element to search for
	 * @returns The index into the tab array
	 */		
	this.getTabIndexById = function(tabDiv, id)
	{
		var index = -1;
		var tabs = this.getTabsForDiv(tabDiv);
		tabs.each(function(i)
		{
			if (tabs.eq(i).children('a').first().attr('id') == id)
			{
				index = i;
				// break out of the .each function
				return false; 
			}
			return true;			
		});
		return index;
	};
	/**
	 * Close a tab index by html anchor id
	 * @param tabDiv The tab container to search	 
	 * @param id The id of the html element to search for
	 */			
	this.closeTabById = function(tabDiv, id)
	{
		var index = this.getTabIndexById(tabDiv, id);
		if (index > -1)
		{
			this.closeTabByIndex(tabDiv, index);
		}
	};
	/**
	 * Close a tab index by the text displayed
	 * @param tabDiv The tab container to search	 
	 * @param text The text displayed on the tab
	 */				
	this.closeTabByText = function(tabDiv, text)
	{
		var index = this.getTabIndexByText(tabDiv, text);
		if (index > -1)
		{
			this.closeTabByIndex(tabDiv, index);
		}
	};
	/**
	 * Close the currently selected tab
	 * @param tabDiv The tab container to search	 	 
	 */					
	this.closeSelectedTab = function(tabDiv)
	{
		var index = this.getSelectedTabIndex(tabDiv);
		if (index > -1)
		{
			this.closeTabByIndex(tabDiv, index);
		}
	};
	/**
	 * Get a tab by case id
	 * @param tabDiv The tab container to search	 	 
	 * @param caseId The id of the case record
	 * @returns Tab element
	 */						
	this.getCaseTabPanel = function(tabDiv, caseId)
	{
		var caseTabPanel = undefined;
		var tabs = jsPAL.getTabsForDiv(tabDiv);
		tabs.each(function(i)
		{
			var tabPanelDiv = jsPAL.getTabPanelDiv(tabDiv, i);
			if (tabPanelDiv.attr('tablename') === 'case' && tabPanelDiv.attr('primarykey') === caseId.toString())
			{
				caseTabPanel = tabPanelDiv;
				return false;
			}
			return true;
		});
		return caseTabPanel;
	};
	/**
	 * Close a tab by case id
	 * @param tabDiv The tab container to search	 	 
	 * @param caseId The id of the case record
	 */							
	this.closeCaseTab = function(tabDiv, caseId)
	{
		var tabs = jsPAL.getTabsForDiv(tabDiv);
		tabs.each(function(i)
		{
			var tabPanelDiv = jsPAL.getTabPanelDiv(tabDiv, i);
			if (tabPanelDiv.attr('tablename') === 'case' && tabPanelDiv.attr('primarykey') === caseId.toString())
			{
				// click the X on the tab to close it
				$(this).find('a[href=closebutton]').click();
				$(document).trigger('PALCaseTabClosed', caseId);
				// break from tabs.each()
				return false;
			}
			// continue tabs.each()
			return true;
		});
	};
	/**
	* Get the tab index for a case
	*/
	this.getCaseTabIndex = function(tabDiv, caseId)
	{
		var index = -1;
		var tabs = jsPAL.getTabsForDiv(tabDiv);
		tabs.each(function(i)
		{
			var tabPanelDiv = jsPAL.getTabPanelDiv(tabDiv, i);
			if (tabPanelDiv.attr('tablename') === 'case' && tabPanelDiv.attr('primarykey') === caseId.toString())
			{
				index = i;
				return false;
			}
			return true;
		});
		return index;
	};
	/**
	 * Set a tab's text
	 * @param tabDiv The tab container 	 	 
	 * @param index The index into the tab array
	 * @param text The caption to set
	 */		
	this.setTabText = function(tabDiv, index, text)
	{
		// div is the id of the div that contains the tabs
		// index is the zero relative tab index
		var tabs = this.getTabsForDiv(tabDiv);
		tabs.eq(index).children('a').first().text(text);
	};
	/**
	 * Set the currently selected tab's text
	 * @param tabDiv The tab container 	 	 	 
	 * @param text The caption to set
	 */		
	this.setSelectedTabText = function(tabDiv, text)
	{
		this.setTabText(tabDiv, this.getSelectedTabIndex(tabDiv), text);
	};
	/**
	 * Is the tab locked
	 * @param tabDiv The tab container 	 	 	 
	 * @param index The index into the tab array
	 * @returns True/false
	 */		
	this.isTabLocked = function(tabDiv, index)
	{
		var tabs = this.getTabsForDiv(tabDiv);
		isCurrentlyLocked = tabs.eq(index).find('span').hasClass('ui-icon-locked');
		return isCurrentlyLocked;
	};
	/**
	 * Select a tab by index
	 * @param tabDiv The tab container as a jQuery 	 	 	 
	 * @param index The index into the tab array
	 */		
	this.selectTab = function(tabDiv, index)
	{
		$(tabDiv).tabs('option', 'active', index);
	};
	/**
	 *  return the tab panel for a tab. This is the div that is
	 *  displayed when the tab is selected
	 *
	 * @param tabDiv The tab container as a jQuery
	 * @param index The index into the tab array
	 */
	this.getTabPanelDiv = function(tabDiv, index)
	{
		// get the tabs, which are the <li> elements in the tabDiv
		var tabs = this.getTabsForDiv(tabDiv);
		// get the tab specified by index
		var theTab = tabs.eq(index);
		// get the Id of the div that the tab controls
		var divId = theTab.attr('aria-controls');
		return $('#' + divId);
	};
	this.getSelectedTabPanelDiv = function(tabDiv)
	{
		var index = this.getSelectedTabIndex(tabDiv);
		return this.getTabPanelDiv(tabDiv, index);
	};
	/**
	 * Set a tabs attributes
	 * @param tabdiv The tab container 	 	 	 
	 * @param index The index into the tab array
	 * @param attributes An associative array of attributes to add to the tab
	 */
	this.setTabAttributes = function(tabdiv, index, attributes)
	{
		var tab = tabdiv.find('ul').find('li').eq(index);
		if (tab.length > 0)
		{
			// attributes is an object, e.g. {tablename: 'case',
			// primarykey='3'}
			for (attr in attributes)
			{
				tab.attr(attr, attributes[attr]);
			}
		}
	};
	/**
	 * Set a text string that is prefixed to case tab text
	 * @param tabTextPrefix The prefixed text
	 */
	this.setTabTextPrefix = function(tabTextPrefix)
	{
		jsPAL.tabTextPrefix = tabTextPrefix.toString();
	};
	/** 
	 * Clear the case tab text prefix string
	 */
	this.clearTabTextPrefix = function()
	{
		jsPAL.tabTextPrefix = null;
	};
	/**
	 * Create a droppable target.
	 * @param selector The jquery selector of the droppable
	 * @param accept The selector type of draggable that will be accepted
	 * @param dropFunc The function to call when a draggable is dropped onto the target
	 */
	this.createDroppable = function(selector, accept, dropFunc)
	{
		$(selector).droppable(
		{
			accept : accept,
			activeClass : 'ui-state-hover',
			hoverClass : 'ui-state-active',
			tolerance : 'pointer',
			drop : function(event, ui)
			{
				dropFunc(event, ui);
			}
		});
	};
	/**
	 *  Create draggable item
	 *  @param selector The jquery selector of the draggable elements
	 *  @param helperFunc The drag helper function
	 *  @param the element that contains the draggables (default is the entire document)
	 */
	this.createDraggable = function(selector, helperFunc, container)
	{
		if (undefined === container)
			container = document;
		$(container).find(selector).draggable(
		{
			appendTo : 'body',
			delay : 100,
			cursorAt :
			{
				left : 30,
				bottom : 5
			},
			helper : function(event)
			{
				return helperFunc(event);
			}
		});
	};
	this.nextTab = function()
	{
		alert('Next Tab Clicked');
	};
	this.previousTab = function()
	{
		alert('Previous Tab Clicked');
	};
	/**
	 * Display a notifcation message to the user
	 * @param text The message to display
	 * @param timeout Time in seconds before closing the window
	 */
	this.displayNotification = function(text, timeout)
	{
		var boldIndex = 0;
		var saveText = text;
		var dlg = {};
		if (undefined === timeout)
		{
			timeout = 2; // default 2 second timeout
		}
		if (this.highlightTimer !== 0)
		{
			clearTimeout(this.highlightTimer);
		}
		// get rid of any previous notification which may still be open
		this.closeNotification();
		dlg = $("<div id='notificationDlg' class='notificationDlg'></div>");
		// display a notification box that fades away
		dlg.dialog(
		{
			autoOpen : true,
			resizable : false,
			minHeight : 1,
			minWidth : 1,
			width : 'auto',
			dialogClass : 'notificationDlg',
		}).text(text);
		dlg.parent().find(".ui-dialog-titlebar").hide();
		if (undefined !== timeout && 0 !== timeout)
		{
			setTimeout(function()
			{
				dlg.parent().fadeOut('slow', function()
				{
					jsPAL.closeNotification();
				});
			}, timeout * 1000);
		}
		function highlightLoop()
		{
			jsPAL.highlightTimer = setTimeout(function()
			{
				if (++boldIndex >= saveText.length)
				{
					boldIndex = 0;
				}
				var highlightWidth = 4;
				dlg.html(saveText.substr(0, boldIndex) + '<span class="notificationHighlight" >' + saveText.substr(boldIndex, highlightWidth) + '</span>' + saveText.substr(boldIndex + highlightWidth));
				if (jsPAL.doNotificationHighlight === true)
				{
					highlightLoop();
				}
			}, 50);
		}
		// make dialog wider and recenter it
		var dlgWidth = dlg.width() + 50;
		dlg.dialog({position: 'center', width: dlgWidth});
		// don't do highlightLoop on iPad, doesn't work. Seems to have something to do with the 50ms timeout
		jsPAL.doNotificationHighlight = SystemParms.isiDevice === false;
		if (jsPAL.doNotificationHighlight)
			highlightLoop();
	};
	/**
	 * Close the notifcation message 
	 */	
	this.closeNotification = function()
	{
		var dlg = $("#notificationDlg");
		if (dlg.length > 0)
		{
			this.doNotificationHighlight = false;
			clearTimeout(this.highlightTimer);
			this.highlightTimer = 0;
			if (FunctionExists(dlg.dialog))
			{
				dlg.dialog('close');
				dlg.dialog('destroy');
				dlg.remove();
			}
		}
	};
	/**
	 * Get the sql tablename for the jqgrid
	 * @param gridElement The jqgrid
	 * @returns The sql table name representing DataView.BaseTableName
	 */	
	this.getGridTableName = function(gridElement)
	{
		// tablegrid is a Leica added class, probably should look
		// for ui-jqgrid which is the  jgQrid class
		if ($(gridElement).hasClass('tablegrid') == false)
		{
			// the tablegrid was not passed in, attempt to find it
			// by going up to the main jqGrid container div, and then down
			// to the tablegrid
			gridElement = gridElement.closest('div.ui-jqgrid').find('.tablegrid');
		}
		// return the base table name that is contained in a grid, e.g. Case
		var tableGrid = gridElement;
		if (tableGrid.length === 0)
		{
			return '';
		}
		// this attribute is set by the DisplayJqGrid() function in
		// cList.php
		var tableName = tableGrid.attr('tablename');
		return tableName.toLowerCase();
	};
	/**
	 * Get the sql view name for the jqgrid
	 * @param gridElement The jqgrid
	 * @returns The view name
	 */	
	this.getGridViewName = function(gridElement)
	{
		if ($(gridElement).hasClass('tablegrid') == false)
		{
			// the tablegrid was not passed in, attempt to find it
			// by going up to the main jqGrid container div, and then down
			// to the tablegrid
			gridElement = gridElement.closest('div.ui-jqgrid').find('.tablegrid');
		}
		var tableGrid = gridElement;
		if (tableGrid.length === 0)
		{
			return '';
		}
		// this attribute is set by the DisplayJqGrid() function in
		// cList.php
		var viewName = tableGrid.attr('viewname');
		return viewName.toLowerCase();
	};
	/**
	 * Set admin mode. 
	 * @param adminMode True/False True to set admin mode, and false to reset admin mode
	 */
	this.setPALAdminMode = function(adminMode)
	{
		// set admin mode based on the button checked state,
		// then reload the current URL
		Ajax(
		{
			type : "POST",
			url : "/PALModules/SetPALAdminMode.php",
			data : "adminmode=" + adminMode,
			success : function(msg)
			{
				// reload the current page 
				window.location.reload();
			},
			error : function(jqXHR, textStatus, errorThrown)
			{
			}
		});
	};
	/**
	 * Create the Esignature and RFC popup windows and hide them
	 **/
	this.createModalPopups = function()
	{
		createModalDialog('#RfcDiv', "#RfcDivHeader", 'esigDiv');
		createModalDialog("#esigDiv", '#esigDivHeader', 'esigDiv');
	};
	/**
	 * Compute a person's age from a string.
	 * Must be a 10 character date
	 * @param dob The string date representation of the person's date of birth
	 */
	this.computeAge = function(dob)
	{
		if (undefined === dob || (dob.length != 10))
		{
			return '';
		}
		var dateFormat = SystemParms.DateFormatHint;
		if (dateFormat.length != 10)
		{
			return '';
		}
		// verify that dob is a valid date
		if (SystemParms.DateFormatRegex.test(dob) == false)
		{
			return '';
		}

		var delimiter = SystemParms.DateDelimiter;
		// Make sure a delimiter is actually defined.
		if (delimiter == '')
		{
			delimiter = '/';
		}

		var birthYear = '';
		var birthMonth = '';
		var birthDay = '';

		var splitFormat = dateFormat.split(delimiter);
		var splitDob = dob.split(delimiter);
		if ((splitFormat.length != 3) || (splitDob.length != 3))
		{
			return '';
		}
		// note, we expect the date format to be some arrangement of yyyy mm
		// and dd
		for ( var i = 0; i < 3; i++)
		{
			switch (splitFormat[i])
			{
				case 'yyyy' :
					birthYear = splitDob[i];
					break;
				case 'mm' :
					birthMonth = splitDob[i];
					break;
				case 'dd' :
					birthDay = splitDob[i];
					break;
			}
		}
		var textAge = '';
		var curDate = new Date();
		var curYear = curDate.getFullYear();
		var curMonth = curDate.getMonth() + 1; // getMonth is zero
		// relative, we need 1
		// relative
		var curDay = curDate.getDate();
		var birthDate = new Date(birthYear + '/' + birthMonth + '/' + birthDay);

		if (birthDate < curDate)
		{
			// compute age in months
			var age = (curYear - birthYear) * 12;
			if (age === 0)
			{
				age = curMonth - birthMonth;
			}
			if (birthMonth > curMonth)
			{
				--age;
			}
			else if (birthMonth == curMonth)
			{
				if (birthDay > curDay)
				{
					--age;
				}
			}
			if (age < 12)
			{
				ddiff = curDay - birthDay;
				mdiff = curMonth - birthMonth;
				ydiff = curYear - birthYear;
				
				if(mdiff<0 || ydiff >0) {
					mdiff += 12;	
				}

				if(ddiff<0){ 
					var daysInMonth = new Date(birthYear, birthMonth, 0);
					ddiff= (daysInMonth.getDate()- birthDay)  + curDay;
					--mdiff;
				}
				
				if (mdiff > 0 )
				{
					age = mdiff;
					textAge = age + ' month';
					
				}
				else
				{	
					age = ddiff;			
					textAge = age + ' day';
				}
				if (age !== 1)
				{
					textAge += 's';
				}
			}
			else
			{
				textAge = Math.floor(age / 12);
			}
		}
		return textAge;
	};
	/**
	 * Delete a jqgrid row
	 * @param element The elment that was clicked
	 * @param table The sql table
	 */
	this.deleteGridRow = function(element, table)
	{
		element = $(element);
		// get the database id from the table row
		var id = element.closest('tr').attr('id');
		if (id !== '' && undefined !== table)
		{
			var message = element.attr('message');
			if (undefined !== message && message !== '')
			{
				if (confirm(message) !== true)
				{
					return false;
				}
			}
			this.deleteElement(id, table);
			return true;
		}
		else
		{
			alert('Error determining the Id or database table - Cannot delete the item');
			return false;
		}
	};
	/**
	 * Edit a user's workflow settings
	 * @param element unused
	 */
	this.editSettings = function(element)
	{
		editWorkflowUserSettings();
	};
	/**
	 * Edit slide metadata in a popout modal window
	 * @param slideId The id from the slide table
	 */
	this.editSlide = function(slideId)
	{
		var slideDialog = $("<div id='editSlideDialog'></div>");
		slideDialog.dialog(
		{
			autoOpen : true,
			title : 'Edit Slide',
			modal : true,
			resizable : true,
			height : 420,
			width : 580,
			position : 'top',
			open : function(event, ui)
			{
				// remove the X in the title bar, don't want the user to
				// close that dialog with the X
				$(".ui-dialog-titlebar-close").hide();
				// load the CaseAssembly_SlideInformation_Slide view into
				// the dialog
				$('#editSlideDialog').empty();
				var url = '/PALModules/healthcare/CommonViewDisplay.php';
				var data = 'workFlow[0]=CaseAssembly' + 
						   '&viewName[0]=CaseAssembly_SlideInformation_Slide' + 
						   '&renderMode[0]=MultiColumn' + 
						   '&Table[0][0]=Slide' + 
						   '&FieldName[0][0]=Id' + 
						   '&FieldOperator[0][0]=%3D' + 
						   '&FieldValue[0][0]=' + slideId +
						   '&ReturnImageDataWithSlide=0';	// don't return image data with the slide data
				$('#editSlideDialog').load(url, data);
			},
			close : function(event, ui)
			{
				var listName = $(this).find('.ListTable').attr('id');
				if (undefined !== listName && '' !== listName)
				{
					// remove this list from the GlobalList in list.js
					GlobalList.RemoveList(listName);
				}
				slideDialog.dialog('destroy');
				slideDialog.remove();
			},
			buttons :
			{
				"Save" : function()
				{
					if (isset(NeedCheck))
					{
						NeedCheck = true;
					}
					// close the dialog after Save completes
					$(document).one('OperationQueueComplete', function() {
						slideDialog.dialog('close');
					});
					SaveAll();
				},
				"Reset" : function()
				{
					ResetAll();
				},
				Cancel : function()
				{
					$(this).dialog('close');
				}
			}
		});
	};
	/**
	 * Delete an element using the operations queue. May prompt for RFC
	 * @param id The id from the primary key of the sql table [table]
	 * @param table The sql tablename
	 * @param controlId The id of the control that was clicked to delete this element, e.g. a Delete button
	 * @param operationsEvent Callback event from the Operations queue
	 * @param isImage True/False Set true when deleting a specimen gross image
	 */	
	this.deleteElement = function(id, table, controlId, operationsEvent, isImage)
	{
		var warning = '';
		if (undefined === isImage)
		{
			isImage = false;
		}
		if (isImage)
		{
			warning = 'WARNING:  You are about to permanently delete this ' + table + ' Image<br>Are you sure you want to delete this ' + table + ' Image?';
		}
		else
		{
			if (jsPAL.getPALModuleName() == 'ConsultationRequest')
			{
				warning = 'Note:  Deleting this ' + table + ' will delete this copy from Outgoing Collaboration.<br>Are you sure you want to delete this ' + table + '?';
			}
			else if (jsPAL.getPALModuleName() == 'ConsultationReview')
			{
				warning = 'Note:  Deleting this ' + table + ' will delete this copy from Incoming Collaboration.<br>Are you sure you want to delete this ' + table + '?';
			}
			else
			{
				warning = 'WARNING:  You are about to permanently delete this ' + table + '<br>Are you sure you want to delete this ' + table + '?';
			}
		}
		createModalConfirm(warning,
				function() {
					var notification = 'Deleting ' + table;
					if (isImage)
						 notification += ' Image';
					jsPAL.displayNotification(notification, 60);
					if (table == 'Case')
						jsPAL.closeCaseTab($('#MainTabs'), id);
					if (undefined === operationsEvent)
					{
						operationsEvent = 'PALDeleteElement';
					}
					SetupNodes('/Record_DoDelete.php', 'PalOperationsNode');
					jsPAL.PALOperationsNode.Parms = (isImage ? 'ImageIds[]=' : 'Ids[]=') + id + '&TableName=' + table;
					jsPAL.PALOperationsNode.OperationsEvent = operationsEvent;
					if (undefined !== controlId)
					{
						jsPAL.PALOperationsNode.ControlId = controlId;
					}
					else
					{
						delete jsPAL.PALOperationsNode.ControlId;
					}
					jsPAL.PALOperationsNode.TableName = table;
					jsPAL.PALOperationsNode.Ids = id;
					jsPAL.runOperationsQueue();
					return true;
				}, "OK", 
				function() {
					return false;
				}, "Cancel", "Confirm Delete", 'deleteConfirm', 1);
	};
	/**
	 * Delete a document using apache
	 * @param id The primary key from the documents table
	 * @param controlId The html id of the control that called the event
	 * @param operationsEvent The Event callback
	 **/
	this.deleteDocument = function(id, controlId, operationsEvent)
	{
		this.displayNotification('Deleting Document', 60);
		if (undefined === operationsEvent)
		{
			operationsEvent = 'PALDeleteElement';
		}
		SetupNodes('/Document_DoDelete.php', 'PalOperationsNode');
		this.PALOperationsNode.Parms = 'Ids[]=' + id;
		this.PALOperationsNode.OperationsEvent = operationsEvent;
		if (undefined !== controlId)
		{
			this.PALOperationsNode.ControlId = controlId;
		}
		else
		{
			delete this.PALOperationsNode.ControlId;
		}
		this.PALOperationsNode.TableName = 'Documents';
		this.PALOperationsNode.Ids = id;
		this.runOperationsQueue();
		return true;
	};
	/**
	 * Unassign an element using the operations queue. May prompt for RFC
	 * @param id The id from the primary key of the sql table [table]
	 * @param table The sql tablename
	 * @param controlId The id of the control that was clicked to delete this element, e.g. a Delete button
	 * @param operationsEvent Callback event from the Operations queue	 
	 */	
	this.unassignElement = function(id, table, controlId, operationsEvent)
	{
		if (confirm('WARNING:  You are about to unassign this ' + table + ' from the Case.\nAre you sure you want to unassign this ' + table + '?'))
		{
			this.displayNotification('Unassigning ' + table, 60);
			if (undefined === operationsEvent)
			{
				operationsEvent = 'PALUnassignElement';
			}
			SetupNodes('/BulkAction.php', 'PalOperationsNode');
			this.PALOperationsNode.Parms = 'Command=BulkUnassign&Ids[]=' + id + '&TableName=' + table;
			if (undefined !== controlId)
			{
				this.PALOperationsNode.ControlId = controlId;
			}
			else
			{
				delete this.PALOperationsNode.ControlId;
			}
			this.PALOperationsNode.OperationsEvent = operationsEvent;
			this.PALOperationsNode.TableName = table;
			this.PALOperationsNode.Ids = id;
			this.runOperationsQueue();
			return true;
		}
		return false;
	};
	/**
	 * Assign an element using the operations queue. May prompt for RFC
	 * @param table The sql tablename
	 * @param id The id from the primary key of the sql table [table]
	 * @param parenttable The parenttable name
	 * @param parentid The parent table primary key	 
	 * @param operationsEvent Callback event from the Operations queue	 
	 */		
	this.assignElement = function(table, id, parenttable, parentid, operationsEvent)
	{
		this.displayNotification('Assigning ' + table, 60);
		if (undefined === operationsEvent)
		{
			operationsEvent = 'PALAssignElement';
		}
		SetupNodes('/BulkAction.php', 'PalOperationsNode');
		this.PALOperationsNode.Parms = 'PALMode=true&Command=BulkAddToExistingParent&Ids[]=' + id + '&TableName=' + table + '&ParentId=' + parentid + '&ParentTableName=' + parenttable;
		this.PALOperationsNode.OperationsEvent = operationsEvent;
		this.PALOperationsNode.TableName = table;
		this.PALOperationsNode.Ids = id;
		this.runOperationsQueue();
		return true;
	};
	/**
	 * Add an element using the operations queue. May prompt for RFC
	 * @param table The sql tablename	 
	 * @param parenttable The parenttable name
	 * @param parentid The parent table primary key	 
	 * @param operationsEvent Callback event from the Operations queue	 
	 * @param numElements Optional number of elements to add, default is 1
	 * @param reuseOpParms Optional boolean - if true then reuse OpParms (RFC, eSig) from previous operation
	 */			
	this.addElement = function(table, parenttable, parentid, operationsEvent, numElements, reuseOpParms)
	{
		this.displayNotification('Adding ' + table, 60);
		numElements = (undefined !== numElements) ? numElements : 1;
		if (undefined === operationsEvent)
		{
			operationsEvent = 'PALAddElement';
		}
		SetupNodes('/Record_DoAdd.php', 'PalOperationsNode', reuseOpParms);
		this.PALOperationsNode.Parms = 'PALMode=true&AddMode=AddRecords&AddCount=1&DataGroupId=_HCMain&TableName=' + table +
					 '&ParentTable=' + parenttable + '&ParentId=' + parentid + '&AddCount=' + numElements;
		this.PALOperationsNode.OperationsEvent = operationsEvent;
		this.PALOperationsNode.TableName = table;
		this.runOperationsQueue();
		return true;
	};
	/**
	 * Assign an image using the operations queue. May prompt for RFC
	 * @param table The sql tablename	 
	 * @param parenttable The parenttable name
	 * @param parentid The parent table primary key	 
	 * @param imageLocation The file path to the image
	 * @param operationsEvent Callback event from the Operations queue	 
	 */		
	this.addImage = function(table, parenttable, parentid, imageLocation, operationsEvent)
	{
		this.displayNotification('Adding Image to ' + parenttable, 60);
		if (undefined === operationsEvent)
		{
			operationsEvent = 'PALAddElement';
		}
		SetupNodes('/Record_DoAdd.php', 'PalOperationsNode');
		this.PALOperationsNode.Parms = 'PALMode=true&AddMode=AddImage&AddCount=1&PALMode=true&TableName=' + table + '&ParentTable=' + parenttable + '&ParentId=' + parentid + '&ImageLocation=' + imageLocation;
		this.PALOperationsNode.OperationsEvent = operationsEvent;
		this.PALOperationsNode.TableName = table;
		this.runOperationsQueue();
		return true;
	};
	/**
	 * Re-Assign an image using the operations queue. May prompt for RFC
	 * @param table The sql tablename	 
	 * @param parenttable The parenttable name
	 * @param parentid The parent table primary key	 
	 * @param imageLocation The file path to the image
	 * @param operationsEvent Callback event from the Operations queue	 
	 */		
	this.reassignImage = function(table, parenttable, parentid, imageLocation, operationsEvent)
	{
		this.displayNotification('Reassigning Image to ' + table, 60);
		if (undefined === operationsEvent)
		{
			operationsEvent = 'PALReassignImage';
		}
		SetupNodes('/Record_DoAdd.php', 'PalOperationsNode');
		this.PALOperationsNode.Parms = 'PALMode=true&AddMode=Reassign&AddCount=1&PALMode=true&TableName=' + table + '&ParentTable=' + parenttable + '&ParentId=' + parentid + '&ImageLocation=' + imageLocation;
		this.PALOperationsNode.OperationsEvent = operationsEvent;
		this.PALOperationsNode.TableName = table;
		this.runOperationsQueue();
		return true;
	};
	/**
	 * Add an image to an existing specimen
	 * @param specimenId The id from the specimen table
	 * @param addImageButton 
	 * @param specimenLabel The label name for the specimen
	 */			
	this.addImageToSpecimen = function(specimenId, addImageButton, specimenLabel)
	{
		var imagedlg;
		var addImageDiv = $('<div id="addImageDiv"></div>');
		addImageDiv.load('/AddImage.php', 'ParentId=' + specimenId + '&ParentTable=Specimen&PALMode=true&SpecimenLabel=' + specimenLabel, function()
		{
			// imagedlg.find('input[type=button]').button();
		});
		imagedlg = $('<div id="addImageDlg" ><div id="addImageContent"></div></div>');
		imagedlg.append(addImageDiv);
		$("#dialog:ui-dialog").dialog("destroy");
		imagedlg.dialog(
		{
			autoOpen : true,
			title : 'Add Image to Specimen',
			modal : true,
			resizable : true,
			height : 330,
			width : 780,
			open : function(event, ui)
			{
				// remove the X in the title bar, don't want the user to
				// close that dialog with the X
				$('.ui-dialog-titlebar-close').hide();
				// bind PALAddSpecimenImage handler. This is triggered
				// after the image has been assigned,
				// or not assigned because it is already assigned to a
				// specimen or slide
				$(document).bind('PALAddSpecimenImage', function(event, eventData)
				{
					if (undefined !== eventData.Status && eventData.Status[0] === 'Already Assigned')
					{
						jsPAL.closeNotification();
						if (confirm("The image is already assigned to a Specimen or Slide.\nDo you want to reassign it?"))
						{
							var imageLocation = $('input[name="ImageLocation"]').val();
							jsPAL.reassignImage('Image', 'Specimen', specimenId, imageLocation, 'PALAddSpecimenImage');
						}
						else
						{
							$(document).unbind('PALAddSpecimenImage');
						}
					}
					else if (undefined !== eventData.Status && eventData.Status[0] === 'Already assigned, datagroup permissions do not allow reassignment')
					{
						jsPAL.closeNotification();
						alert('This image is already assigned, and datagroup permissions do not allow you to reassign it');
					}
					else
					{
						if (undefined !== eventData.Ids)
						{
							var imageId = eventData.Ids[0];
							jsCaseAssemblySpecimen.addSpecimenImageThumbnail(imageId);
						}
						$('#addImageDlg').dialog('close');
						$(document).unbind('PALAddSpecimenImage');
					}
				});
			},
			close : function(event, ui)
			{
				imagedlg = null;
				$('#addImageDiv').remove();
				$('#addImageDlg').dialog('destroy').remove();
				// remove the list that was created by AddImage.php from
				// the GlobalList in list.js
				GlobalList.RemoveList('ImageForm');
				// Cleanup any leftover nodes
				NodeCheck();
			},
			buttons :
			{
				'Add Image' : function()
				{
					if (document.FrmMain.AddImageZfuUpload.checked)
					{
						uploadFiles(); // defined in FileUploader.js
					}
					else
					{
						var imageLocation = $('input[name="ImageLocation"]').val();
						if (undefined === imageLocation || '' === imageLocation)
						{
							alert('Please Select an Image First');
						}
						else
						{
							jsPAL.addImage('Image', 'Specimen', specimenId, imageLocation, 'PALAddSpecimenImage');
						}
					}
				},
				'Close' : function()
				{
					$('#addImageDlg').dialog('close');
				}
			}
		});
	};
	/**
	 * Save a html report using the operations queue. May prompt for RFC
	 * @param parentTableName The parenttable name
	 * @param parentId The parent table primary key	 
	 * @param template The reporttemplate name
	 * @param passWord The user's password from the confirmation box	 
	 * @param operationsEvent Callback event from the Operations queue	 
	 * @param status Optional report status. If not present defaults to Final
	 */		
	this.saveReport = function(parentTableName, parentId, template, passWord, operationsEvent, status)
	{
		if (undefined === operationsEvent)
		{
			operationsEvent = 'PALReportSaved';
		}
		SetupNodes('/Report_Save.php', 'PalOperationsNode');
		this.PALOperationsNode.Parms = 'PALMode=1&ParentTable=' + parentTableName + '&ParentId=' + parentId + '&TemplateLocation=' + template + '&Pass=' + passWord;
		if (undefined !== status)
			this.PALOperationsNode.Parms += '&Status=' + status;
		this.PALOperationsNode.OperationsEvent = operationsEvent;
		// disable ajax polling during this lengthy operation
		StopTimer();
		jsPAL.stopPollingLoop();
		// disable the inputs during this lengthy operation
		DisableElements('#GenerateForm input,#GenerateForm select');
		// set a wait cursor
		$('body').css('cursor', 'progress');
		this.runOperationsQueue();
		return true;
	};
	/**
	 * Run the operations queue
	 */
	this.runOperationsQueue = function()
	{
		OperationQueue.Add('SubmitNodes');
		OperationQueue.Add('RefreshGrids');
		// start the queue only if it's not already running
		if (PendingOperationRequests == 0)
			OperationQueue.Run();
	};
	/**
	 * Set the cursor position to the end of a textarea
	 * @param textArea The html texta area control
	 */
	this.setCaretPosition = function(textArea)
	{
		var pos = $(textArea).val().length;
		if (textArea.setSelectionRange)
		{
			textArea.focus();
			textArea.setSelectionRange(pos, pos);
		}
		else if (textArea.createTextRange)
		{
			var range = textArea.createTextRange();
			range.collapse(true);
			range.moveEnd('character', pos);
			range.moveStart('character', pos);
			range.select();
		}
	};
	/** 
	* attempt to get the value of an element for the tableName
	* and column. the id is the HTML id of the element to begin the search
	* at, typically a <div> or <tr>
	* Uses the following algorithm:
	* 1. look for an input for the table/column/primary key, if found
	* return its value
	* 2. look for an element whose attributes match the
	* table/column/primary key, if found return the attribute's value
	* 3. look for a readonly block whose attributes match the
	* table/column/primary key, if found return the attribute's value
	*/
	this.getValue = function(id, tableName, columnName, primaryKey)
	{
		// TODO: implement this
	};

	/**
	 * Find all the visible case rows from the jQGrids
	 * @returns array All of the Case Ids
	 */
	this.getVisibleCaseRows = function()
	{
		return this.getVisibleRows('Case');
	};
	/**
	 * Find all the visible specimen ids from the jQGrids
	 * @returns array All of the Specimen Ids
	 */
	this.getVisibleSpecimenRows = function()
	{
		return this.getVisibleRows('Specimen');
	};
	/**
	 * Find all the visible Slide ids from the jQGrids
	 * @returns array All of the Slide Ids
	 */
	this.getVisibleSlideRows = function()
	{
		return this.getVisibleRows('Slide');
	};
	/**
	 * Find all the visible grid rows from a jqgrid with tablename='XXX'
	 * @param tablename The name of the SQL table to search for
	 * @returns array All of the Ids, in our jQGrids the id columns is the Primary Key
	 */
	this.getVisibleRows = function(tablename)
	{
		var rowsVisible = [];
		$('table[tablename="' + tablename + '"] tr').each( function()
		{
			var rowId = $(this).attr('id');
			if (rowId)
			{
				rowsVisible.push(rowId);
			}
		});
		return rowsVisible;
	};
	
	/*
	 * Extend jQuery with a method to set/get JUST the text content of an element (and leave the child elements alone)
	 */
	$.fn.extend({
		textOnly: function(t){
			return this.each(function(a,b){
				$(b).contents().filter(function(){
					return this.nodeType === 3
				}).first().replaceWith(t);               
			});
		}
	});


	/*
	 * Extend jQuery with a method to check for the existence of any one of many classes
	 */
	$.fn.hasAnyClass = function() {
		var classes = arguments[0].split(" ");
		for (var i = 0; i < classes.length; i++) {
			if (this.hasClass(classes[i])) {
				return true;
			}
		}
		return false;
	}
	
	/**
	 * Given a progress bar div, find the upload status attribute value for the associated parent table row
	 * Note: Assumes that the upload status attribute is on the parent table row, and its name ends with the text 'uploadstatus'
	 */
	this.getProgressUploadStatusFromParentTableRow = function(progressBarDiv)
	{		
		var uploadStatus = "";
		try {
			$(progressBarDiv).closest('tr').each( function()
			{
				$.each(this.attributes, function(i,a){
					if (a.name.indexOf('uploadstatus') > 0) {
						uploadStatus = a.value;
						return false; // exit loop
					} else return true; // continue (not needed, but NetBeans stops complaining)
				});       
			});              
		} 
		catch (exception) { 
			// swallow exceptions
		}
		return uploadStatus;
	};
	
	 
	/**
	* Sets the color and text of the progress bar
	* @param progressBarDiv The html outer div of the progress bar
	* @param progVal The progress value
	*/
	this.setProgressBarColors = function (progressBarDiv, progVal)
	{
		try
		{

			//setup all of the CSS styles for the progress bar
			//clear the number out of the div
			$(progressBarDiv).removeClass('quarter half threequarter full complete');
			
			   //set the color of the progress bar to match the css styles
				if (progVal <= 25)
				{
					$(progressBarDiv).addClass("quarter");
				}
				else if (progVal <= 50)
				{
					$(progressBarDiv).addClass("half");
				}
				else if (progVal <= 75)
				{
					$(progressBarDiv).addClass("threequarter");
				}
				else if (progVal < 100)
				{
					$(progressBarDiv).addClass("full");
				}
				else if (100 === progVal)
				{
					$(progressBarDiv).addClass("complete");
				}                    
			 
		}
		catch (err)
		{
		//swallow any weird progress percentage problems
		//do not want to crash the page because the % complete is strange
		}
	};
	

	/**
	* Sets the caption the progress bar (stored in a span)
	* @param progressBarDiv The html outer div of the progress bar
	* @param caption The progress bar caption
	*/
	this.setProgressBarCaption = function (progressBarDiv, caption)
	{
		try
		{
			$(progressBarDiv).children('span').html(caption);
		}
		catch (err)
		{
			// swallow any weird caption problems. do not want to crash the page because the caption is not working
		}
	};
	
	/**
	* Sets the tooltip of the progress bar
	* @param progressBarDiv The html outer div of the progress bar
	* @param toolTip The text of the tool tip
	*/
	this.setProgressBarToolTip = function (progressBarDiv, toolTip)
	{
		try
		{
			// change to find closest parent td
			//$(progressBarDiv).parent().parent().attr('title', toolTip); // and tooltip
			$(progressBarDiv).closest('td').attr('title', toolTip); // and tooltip
			
		}
		catch (err)
		{
			//swallow any toolTip problems. do not want to crash the page because the tooltip is not working
		}
	};

	/*
	* Update the progress bar CSS class based on rolled up status string for the entity
	* Also update the tool tip for the progress bar based on the status and progress values  
	* @param progressBarDiv The html outer div of the progress bar 
	* @param uploadStatus text string representing upload status, matches enum
	* @param progVal number representing the upload progress
	*/   
	this.setProgressBarStatus = function(progressBarDiv, uploadStatus, progVal)
	{
		// Note: 'started' is not actually a status stored in the database;
		// it is a css class used to show the busy indicator when uploading has started,
		// but before any upload progress has accrued
		// 
		// remove all the status classes first
		$(progressBarDiv).removeClass('fail queued started uploading retrying');
		
		try {
			switch (uploadStatus.toString().toUpperCase()) {
			case jsPAL.progressBarUploadStatusEnum.FAILED:
				$(progressBarDiv).addClass('fail');
				jsPAL.setProgressBarToolTip(progressBarDiv,'One or more files failed to upload.');                
				break;
			case jsPAL.progressBarUploadStatusEnum.QUEUED:
				if (progVal == 0)
					$(progressBarDiv).addClass('queued');
				else
					$(progressBarDiv).addClass('uploading');                    
				jsPAL.setProgressBarToolTip(progressBarDiv,'The item has been queued for upload.');                
				break;
			case jsPAL.progressBarUploadStatusEnum.UPLOADING:
				if (progVal == 0)
				{
					$(progressBarDiv).addClass('started uploading');
					jsPAL.setProgressBarToolTip(progressBarDiv,'No files for this item have been uploaded yet.');               
				}
				else
					$(progressBarDiv).addClass('uploading');
				break;            
			case jsPAL.progressBarUploadStatusEnum.RETRYING:
			   $(progressBarDiv).addClass('retrying');
				jsPAL.setProgressBarToolTip(progressBarDiv,'One or more files failed to upload; scheduled for retry shortly.');                
			   break;
			default:
				if (progVal == 0)
				{
					jsPAL.setProgressBarToolTip(progressBarDiv, 'None of the files for this item have been uploaded yet.');
				}                  
				break;
			}              
		} 
		catch (exception) { 
		  // swallow errors  
		}                          
	}

	/*
	* Update the caption and tool tip of the progress bar based on the value  
	* @param progressBarDiv The html outer div of the progress bar 
	* @param progVal numeric value of the progress bar
	*/
	this.setProgressBarValueText = function(progressBarDiv, progVal)
	{
		try {
			var caption = '';
			
			if (progVal != 0)
			{
				//set the the % complete inside of the progress bar's caption (a span added to the prog bar div during setup)
				if (!$(progressBarDiv).hasAnyClass('fail started queued retrying'))
				{   
					caption = progVal.toFixed(jsPAL.progressBarPrecision) + '%';
					jsPAL.setProgressBarToolTip(progressBarDiv, caption + ' of the files for this item have been uploaded.');
				}                    
			}
			jsPAL.setProgressBarCaption(progressBarDiv, caption);

		}
		catch(exception) {
			// swallow exceptions
		}       
	}
   

	/**
	 * Updates the progress bars on all of the grids
	 * Sets up the progressbar change and complete event handlers
	 * Note: To change the colors edit the style sheet NOT the javascript
	 */
	this.styleGridTransferProgressFromExistingCriticalRowColumns = function()
	{
		var me = this;
		
		//update the percent complete on the grids to use jquery ui progress bar
		var transferProgressSelectors = ["DownToVwCaseAggregatesByCaseId.TransferProgress",
		"DownToVwSpecimenAggregatesBySpecimenId.TransferProgress",
		"DownToVwSlideAggregatesBySlideId.TransferProgress"];

		//loop over all possible divs that have the TransferProgress field
		for (var i=0; i < transferProgressSelectors.length; i++)
		{
			var selector = transferProgressSelectors[i];
			var selectorString = "div[columnname='" + selector + "']";
			$(selectorString).each(function(index)
			{
				// create the progress bar if necessary
				if (!$(this).is(':ui-progressbar')) // this is supposedly the 'offical' way to detect jQueryUI widget' (https://groups.google.com/forum/?fromgroups=#!topic/jquery-ui/iIAAONDiXfg)
				{
					//get the number that is printed in the grid
					var progVal = parseInt($(this).text());
					if (progVal == undefined)
						progVal = 0;
					// remove the div's text content (the transfer progress number) and use a <span> instead (so we can center the text properly)
					// Note that if we don't get rid of the text here, the progress bar will not draw correctly when used with the <span> for the caption
					$(this).addClass("progress").textOnly(''); // this special function will clear only the text of the div (which is the progress value) and preserve child elements
					// create the progress bar; set the inital value and set up listeners
					$(this).progressbar(
					{
						value: progVal,
						max: 100,
						change: function( event, ui ) {
							var progVal = $(this).progressbar('value');
							//me.setProgressBarColors($(this),progVal); // uncomment to re-enable progress bar colors
							me.setProgressBarValueText($(this),progVal);
						},
						complete: function( event, ui ) {               
							var tablename = $(event.target).attr("tablename");
							if (tablename === 'Case')
							{
								me.refreshJQGrids(); // When the case upload progress reaches 100 percent, refresh grid so case can move to upload 'filter'
							}
						}
					}).append('<span class="pbCaption"></span>'); // add a span to hold caption
									
					// Trigger change event to generate colors
					//$(this).progressbar().triggerHandler('change'); // does not work except with explicitly bound listener
					me.setProgressBarStatus($(this),jsPAL.getProgressUploadStatusFromParentTableRow($(this)), progVal);  // update status (border highlight)                   
					$(this).progressbar('option', 'change').call($(this)); // call the change event function
				}
			});
		}
	};
	
	/**
	 * Check JSON object from a AjaxReply() from the dataserver
	 * @param jsonData The json data object
	 * @returns boolean True, if jsonData['ASResult'] === 0
	 */
	this.checkDataServerResultForError = function (jsonData)
	{
		try
		{
			if (jsonData.hasOwnProperty('ASResult'))
			{
				return (parseInt(jsonData['ASResult']) < 0);
			}
			if (0 === jsonData)
			{
				//CheckDbResult() sets the return value to straight up zero
				// zero implies "no error"
				//
				//	if ($Result == 0)
				//		return 0;
				//
				return false;
			}
			if ('0' === ParseJson(jsonData))
			{
				return false;
			}
			//any other possible success criteria could go here
			return true;
		}
		catch (err)
		{
			//swallow ANY error
			return true;
		}
		//has an error
		return true;
	};	

	/**
	 * NavGrid buttons are 'select columns button' & 'default columns button' on the footer of the grid
	 * Show the NavGrid buttons only when the case grid row is in a collapsed state (+ icon)
	 * Hide the NavGrid buttons whenever the case grid row is in expanded state (- icon)
	 * @param grid is the table (aka grid) we have on the page
	 */
	this.toggleNavGridButtons = function (grid) {
		// Each grid view (All Cases, Completed etc.) has it's own nav grid buttons
		var parentGridView = grid.closest('div.ui-jqgrid-view').parent();

		parentGridView.find('#SelectColumnsNavGridButton').toggle();
		parentGridView.find('#DefaultColumnsNavGridButton').toggle();
	}

};
/**
 * Settings popup
 */
function editWorkflowUserSettings()
{
	if (isInitializedDialog('editSettingsDialog') === false)
	{
		var settingsDialog = $("<div id='editSettingsDialog'></div>");

		settingsDialog.dialog(
		{
			autoOpen : false,
			title : 'Configure My Settings',
			modal : true,
			resizable : false,
			minheight : 520,
			// Minimum H x W pixels are different in IE/FF; set
			// +25px to minimize chance of getting scroll bars
			width : 665,
			open : function(event, ui)
			{
				$(".ui-dialog-titlebar").hide();
			},
			close : function(event, ui)
			{
				$('div#DialogErrorBox').remove();
				$(this).empty();
			},
			buttons :
			{
				"Save" : function()
				{
					var successString = '';

					Ajax(
					{
						type : "POST",
						url : "/DoEditSelf.php?PALMode=true",
						data : $("form[name='SettingsForm']").serialize(),
						success : function(response)
						{                                                                     
							// Spectrum returns a 'null' or empty '\r\n' string
							// when updating the password succeeded.
							var msg = response.replace(/\r\n/g, "");
							if (msg === successString || msg === null || msg === undefined)
							{
								$('#editSettingsDialog').find('input.Modified').removeClass('Modified');
								$("#editSettingsDialog").dialog('close');
								// don't attempt to reload the page if edits have been made
								// on any of the tabs for this case.
								if ($('input.Modified').length == 0)
								{
									jsPAL.displayNotification('Settings updated successfully');
									window.location.reload();
								}
								else
								{
									jsPAL.displayNotification('Please save your changes and reload this page for the new settings to take effect', 4);
								}
								
							}
							// .ajax 'success' simply means the request
							// completed. There may be an issue with the
							// password.
							else
							{
								DisplayErrorBoxInSettingsPopup(response);
							}
						},
						error : function(jqXHR, textStatus, errorThrown)
						{
							alert('Error editing Settings - status = ' + textStatus + ' error = ' + errorThrown);
							$(this).dialog('close');
						}
					});
				},
				Cancel : function()
				{
					$(this).dialog('close');
				}
			}
		});
	}

	// Get the form for user settings
	Ajax(
	{
		type : "GET",
		url : "/EditSelf.php?PALMode=true",
		success : function(data)
		{
			$('#editSettingsDialog').html(data).dialog('open');
		},
		error : function(jqXHR, textStatus, errorThrown)
		{
			alert('Error loading Settings - status = ' + textStatus + ' error = ' + errorThrown);
		}
	});
}
/**
 * Positions the error string at the top of the Settings dialog popup window
 */
function DisplayErrorBoxInSettingsPopup(textString)
{
	var dialogErrorBox = $('div#DialogErrorBox');

	// remove json inserted quotes
	textString = textString.replace(/["']{1}/gi, "");

	if (dialogErrorBox.length === 0)
	{
		// Create the errorBox div by copying the div structure of the PAL error
		// box and changing its id
		var errorBoxDiv = $('div.ErrorBox').clone();
		errorBoxDiv.attr('id', 'DialogErrorBox');
		errorBoxDiv.find('td.ErrorBox').text(textString);
		$('div#editSettingsDialog').before(errorBoxDiv);
	}
	else
	{
		dialogErrorBox.find('td.ErrorBox').empty().text(textString);
	}
}
/**
 * Turn div into a modal popup
 */
function createModalDialog(dlgDiv, dlgHeader, dlgClass)
{
	// Move text from header to title
	var dlgTitle = $(dlgHeader).text();
	$(dlgHeader).html('');
	// turn any buttons into jQuery buttons
	$(dlgDiv).find('input:button').button();
	$(dlgDiv).dialog(
	{
		title : dlgTitle,
		dialogClass : dlgClass,
		autoOpen : false,
		resizable : false,
                width: '400px',
		open : function()
		{
			// remove the X in the title bar used to close the dialog box
			$(this).parent().find("a.ui-dialog-titlebar-close").remove();
			// this resolves the z-index issue so that users can enter text and
			// see title bar too
			$(this).find('input:text').css("z-index", 99999);
		},
		modal : true
	});
}
/**
 * 	JQuery UI modal replacement for the confirm() js function :
 * 	@param dialogText  The text displayed in the body of the dialog
 * 	@param okFunction  The js function called when the user presses ok
 * 	@param okButtonString The text of the ok button
 * 	@param cancelFunction  The js function called when the user presses the cancel button
 * 	@param cancelButtonString The text of the cancel button
 * 	@param dialogTitle The text for the title of the dialog
 *	@param dialogId The dialog id (optional, default is 'modalConfirmDlg')
 *  @param defaultButton default button number, zero relative
*/
function createModalConfirm(dialogText, okFunction, okButtonString, cancelFunction, cancelButtonString, dialogTitle, dialogId, defaultButton)
{
	if (undefined === dialogId)
	{
		dialogId = 'modalConfirmDlg';	
	}
	// for some reason on IE8 drop down select box 'onchange' event fired twice
	// so to avoid creating extra dialog box check if it is exist
	if ($('#' + dialogId).length > 0)
	{
		return;
	}
	$('<div id="' + dialogId + '" style="padding: 10px; max-width: 640px; word-wrap: break-word;">' + dialogText + '</div>').dialog(
	{
		draggable : false,
		modal : true,
		resizable : false,
		width : 'auto',
		title : dialogTitle || 'Confirm',
		minHeight : 150,
		open: function (event, ui)
		{
			// if defaultButton specified, and it is a number
			if (undefined !== defaultButton && (defaultButton - 0) == defaultButton)
			{
				$(this).parent().find('.ui-dialog-buttonpane button:eq(' + defaultButton +')').focus();
			}
		},
		close : function(event, ui)
		{
			// for all browsers when dialog box is closed its is set to invisible
			// and reopening it won't work
			// in order to make  the dialog box to appear next time user makes same action the  box need to be removed when closing it
			$(this).dialog('destroy');
			$(this).remove();
		},
		buttons :
		[
		{
			text : okButtonString,
			click : function()
			{
				if (typeof (okFunction) == 'function')
				{
					setTimeout(okFunction, 100);
				}
				$(this).dialog('destroy');
				$(this).remove();
			}
		},
		{
			text : cancelButtonString,
			click : function()
			{
				if (typeof (cancelFunction) == 'function')
				{
					setTimeout(cancelFunction, 100);
				}
				$(this).dialog('destroy');
				$(this).remove();
			}
		}]
	});
}
/**
 * 	JQuery UI modal replacement for the confirm() with three buttons js function :
 * 	@param dialogText  The text displayed in the body of the dialog
 * 	@param okFunction  The js function called when the user presses ok
 * 	@param okButtonString The text of the ok button
 * 	@param noFunction  The js function called when the user presses no
 * 	@param noButtonString The text of the no button
 * 	@param cancelFunction  The js function called when the user presses the cancel button
 * 	@param cancelButtonString The text of the cancel button
 * 	@param dialogTitle The text for the title of the dialog
 *	@param dialogId The dialog id (optional, default is 'modalConfirm3BtnDlg')
 */
function create3ButtonModalConfirm(dialogText, okFunction, okButtonString, noFunction, noButtonString, cancelFunction, cancelButtonString, dialogTitle, dialogId)
{
	if (undefined === dialogId)
		dialogId = 'modalConfirm3BtnDlg';
	$('<div id="' + dialogId + '" style="padding: 10px; max-width: 640px; word-wrap: break-word;">' + dialogText + '</div>').dialog(
	{
		draggable : false,
		modal : true,
		resizable : false,
		width : 'auto',
		title : dialogTitle || 'Confirm',
		minHeight : 150,
		close : function(event, ui)
		{
			// for all browsers when dialog box is closed its is set to invisible
			// and reopening it won't work
			// in order to make  the dialog box to appear next time user makes same action the  box need to be removed when closing it
			$(this).dialog('destroy');
			$(this).remove();
		},
		buttons :
		[
		{
			text : okButtonString,
			click : function()
			{
				if (typeof (okFunction) == 'function')
				{
					setTimeout(okFunction, 100);
				}
				$(this).dialog('destroy');
				$(this).remove();
			}
		},
		{
			text : noButtonString,
			click : function()
			{
				if (typeof (noFunction) == 'function')
				{
					setTimeout(noFunction, 100);
				}
				$(this).dialog('destroy');
				$(this).remove();
			}
		},
		{
			text : cancelButtonString,
			click : function()
			{
				if (typeof (cancelFunction) == 'function')
				{
					setTimeout(cancelFunction, 100);
				}
				$(this).dialog('destroy');
				$(this).remove();
			}
		}]
	});
}
/** 
 * jQuery bug: Ticket #5466
 * z-index on input element is trumped by the widget's z-index:
 * Bump the input elements z-index above the dialog widget container else cannot
 * edit field
 * Do this once after initialization. Must reset z-index (dialog function does
 * not work, do by self)
 * as each subsequent opening of the dialog will create a max z-index > any
 * elements in div.
 * 2012-03-05 Dialog for RFC/ESIG using the dialog UI moveToTop method which
 * seems to have successfully replaced this method.
 * @param dlgDiv The div attached to the dialog
 * @param startString The html input's id must contain this string
 * @param changeZIndexBy Integer to set the z-index by
 */
function changeTdInputZIndex(dlgDiv, startString, changeZIndexBy)
{
	var zIndex = $(dlgDiv).dialog('option', 'zIndex') + changeZIndexBy;
	var Inputs = $(dlgDiv + ' td input[id^=' + startString + ']');
	if (Inputs.length > 0)
	{
		Inputs.each(function()
		{
			$(this).css('z-index', zIndex);
		});
	}
}
/**
 * Called when a jqGrid load has completed, 
 * @param data Is the data from the grid callback
 */
function jqGridLoadComplete(data)
{	
	var grid = $(this);
	if (undefined === grid.data("origColNames"))
	{
		// save the initial colNames
		var colNames = grid.jqGrid("getGridParam", "colNames");
		// get a copy of the colNames array
		grid.data("origColNames", CopyObject(colNames));
		var colModel = grid.jqGrid("getGridParam", "colModel");
		grid.data("origColModel", CopyObject(colModel));
		RemapGrid(grid);
	}
	// delay loaded grids do not have any customRowAttributes until they fetch
	// the data
	var customRowAttributes = data.CustomRowAttributes;
/////	grid.jqGrid('setFrozenColumns');
	// if ClueTips exist, set the delimiter to '|'. The delimeter is used to
	// separate the toolbar title from the text
	var clueTipTitleDelimiter = typeof ($('*').cluetip) == 'function' ? '|' : '';
	var len = 75;

	// Select * from datafields where IsCritical = 1
	for ( var rowIdKey in customRowAttributes)
	{
		var searchRow = grid.find('#' + rowIdKey);
		var customAttrs = customRowAttributes[rowIdKey];
		if (0 !== searchRow.length)
		{
			for ( var rowAttr in customAttrs)
			{
				searchRow.attr(rowAttr, customAttrs[rowAttr]);
			}
		}
	}
	jsPAL.resizeJQGrids();
	grid.find("tr.jqgrow:odd").addClass("altgridrow");

	var gridTableName = jsPAL.getGridTableName($(this));
	// add a class to each TR that indicates the type of data in the row, e.g.
	// case
	grid.find("tr").addClass(gridTableName);
	// add a class to each TR that indicates the workflow that contains the
	// data, e.g. DigitalReview,
	// this is used by droppables to accept data only from specific workflows
	grid.find("tr").addClass(jsPAL.PALModuleName);

	// get the column headers
	var thead = $(grid)[0].grid.hDiv;
	var hdrs = $(thead).find('th');

	grid.find("td").each(function(i)
	{
		if ($(this).hasClass("field"))
		{
			// limit any TD that has class 'Field' to have no more than 75
			// characters. Add a ClueTip tooltip to any
			// TDs that are truncated to 75 characters. The tooltip contains the
			// original untruncated text
			var td = $(this)[0];
			// drill down to the innermost element to get text
			var innerElement = $(this).find('*').last();
			var html = innerElement.html();
			if (html)
			{
				currLen = html.length;
				if (currLen > len)
				{
					// Make sure innerHTML does not contain any textarea tags
					for ( var ii = 0; ii < td.childNodes.length; ii++)
					{
						if (td.childNodes[ii].tagName == "TEXTAREA")
						{
							continue;
						}
					}
					// set a tooltip which is the entire innerHTML prior to
					// being truncated
					td.title = clueTipTitleDelimiter; // default to no title
					// in the clue tooltip
					// get the index of this td in the tr
					var idx = $(this).closest('tr').find('td').index(td);
					if (idx > -1)
					{
						// get the column headers
						if (hdrs.length > idx)
						{
							// get column name from header cell
							var colName = hdrs.eq(idx).text();
							if (colName !== '')
							{
								td.title = colName + clueTipTitleDelimiter; // set
							}
						}
						td.title += html;
					}
					innerElement.html(html.substr(0, len) + '...');
					if (typeof ($(td).cluetip) == "function")
					{
						$(td).cluetip(
						{
							splitTitle : "|",
							dropShadow : true,
							cursor : "",
							leftOffset : 0,
							arrows : false,
							cluetipClass : "HealthCare"
						});
					}
				}
			}
		}
	});

	//set the initial progress value
	jsPAL.styleGridTransferProgressFromExistingCriticalRowColumns();

	// load any delay load thumbnail images
	ImageLoad();
	// don't allow deleting thumbnails from grids
	grid.find('.thumbnailDelLink').remove();
	// remove the Delete Image tooltip
	grid.find('[title="Delete Image"]').removeAttr('title');
	// don't allow opening images from grids
	grid.find('.thumbnailDiv').find('a').removeAttr('onclick').attr('href', '#');
	$(document).trigger('PALGridLoadCompleteEvent', grid);
	$(document).trigger('RenameResultDescriptionGridsEvent', grid);
	$(document).trigger('WorkflowSpecificLockingTabLogic', grid, false);
	$(document).trigger('PALRepositionCommandBar');
	// disable clicking of any thmubnail images inside of jqgrids
	$("div.ui-jqgrid div.thumbnailDiv img").bind("click", function(event)
	{
		return false;
	});

	// Navgrid buttons are (should be) visible in the case grid only
	// Attach the click event for each view as all grid views (All Cases, Completed etc.) have their own buttons
	if (grid.hasClass('ui-jqgrid-btable') && grid.is(":visible") && grid.attr('tablename') == 'Case') {
		grid.find('td.ui-sgcollapsed').on('click', function() { // + or - icon
			jsPAL.toggleNavGridButtons(grid);
		});
	}
}

/**
 * Add a Select Columns and Default Columns buttons to a jqGrid's Navigator
 * @param grid  
 */
function AddNavGridButtons(grid) 	
{
	//
	// a jqGrid is structured as follows:
	//		<div.ui-jqgrid>     				- the top level jqGrid container.
	//			<div.ui-jqgrid-view>			- the grid view container
	//				<div.ui-jqgrid-hdiv>		- the column header div
	//				<div.ui-jqgrid-bdiv>		- the body container div
	//					<div.ui-jqgrid-btable>	- the actual grid body table. this is the div that the jqGrid function calls should be made on
	//				</div.ui-jqgrid-bdiv>		- end of the body div
	//			</div.ui-jqgrid-view>			- end of the grid view
	//			</div.ui-jqgrid-pager>			- the pager bar (contains the Navigator)
	//		</div.ui-jqgrid>                	- end of jqGrid container
	//

	// make sure grid it is on the first Main tab, really is a jqGrid, is visible, and is for the Case table.
	if (jsPAL.getSelectedTabIndex($('#MainTabs')) == 0 && grid.hasClass('ui-jqgrid-btable') && grid.is(":visible") && grid.attr('tablename') == 'Case')
	{
		// to locate the pager, go up from the .ui-jqgrid-btable to the .ui-jqgrid-view div,
		// and then find the .ui-jqgrid-pager, which is a sibling of the .ui-jqgrid-view
		var gridId = '#' + grid.attr('Id');
		var pagerId = '#' + grid.closest('div.ui-jqgrid-view').siblings('div.ui-jqgrid-pager').attr('Id');
		if (pagerId != '#' && gridId != '#')
		{
			// navGrid returns the Navigator, which is contained within the pager.
			// navButtonAdd will add a button to the Navigator. All other predefined Navigator buttons are hidden.
			var navGrid = grid.jqGrid('navGrid', pagerId, {edit:false,add:false,del:false,search:false,refreshicon:false,refresh:false});
			// prevent duplicate buttons
			if (grid.find('#SelectColumnsNavGridButton').length == 0)
			{
				navGrid.jqGrid('navButtonAdd', pagerId,
				{
					caption:'Select Columns', 
					title:'Select Which Columns Are Visible in the Grid',
					buttonicon:'ui-icon-calculator',
					position:'last',
					id: 'SelectColumnsNavGridButton',
					onClickButton: function(){
						grid.data('columnsAreRemapped', true);
						grid.jqGrid('columnChooser', {
							modal: true,
							classname: "column-chooser-wrap",
							height:400,
							msel_opts: {dividerLocation: 0.5},
							done: function (perm) {
								if (undefined !== perm)
								{
									var oldColModel = grid.jqGrid ("getGridParam", "colModel");
									var oldColNames = grid.data("origColNames");
									grid.jqGrid('remapColumns', perm, true);
									var newColNames = grid.jqGrid("getGridParam", "colNames");
									// new build a remap based on the original column names
									var remap = BuildGridRemap(oldColNames, newColNames);
									SaveColModel(gridId, oldColModel, remap);
								}
							}
						})
					}
				});
			}
			if (grid.find('#DefaultColumnsNavGridButton').length == 0)
			{
				navGrid.jqGrid('navButtonAdd', pagerId,
					{
						caption:'Default Columns', 
						title:'Restore Default Column Positons, Widths and Sizes',
						buttonicon:'ui-icon-home',
						position:'last',
			   			id: 'DefaultColumnsNavGridButton',
						onClickButton: function(){
							createModalConfirm("Restore Default Column Settings?<br><br>If you click the Yes button,this page will be reloaded<br>with the default column settings.",
								function(){  // Yes function
								$.ajax(
								{
									type: "POST",
									url: "/jqGridColModelConfig.php",
									data: "action=delete&component=Spectrum&name=" + $(gridId).attr('viewname'),
									success: function (){
										// reload the current page
										window.location.reload();	
									}
								});
								}, "Yes",
								function(){},  // No function
								 "No",
								"Restore Default Columns", undefined, 1);
					   }
					}
				); 
			}
		}
	}
}

/***
* Build a new colModel for the grid, and save the model to the database
* 
* @param gridId
*/
function BuildNewColModel(gridId)
{
	// need to build a new colModel relative to the original column positions, which are not necessarily
	// the same as the previous positions
	var oldColNames = $(gridId).data("origColNames");
	var newColNames = $(gridId).jqGrid("getGridParam", "colNames");
 	// new build a remap based on the original column names
 	var remap = BuildGridRemap(oldColNames, newColNames);
	SaveColModel(gridId, null, remap);
}
/***
* build a jqGrid remap, to map the new column positions
* 
* @param oldColNames
* @param newColNames
* 
* @returns {Array}
*/
function BuildGridRemap(oldColNames, newColNames)
{
 	var remap = [];
 	for (var i = 0; i < newColNames.length; i++)
 	{
		for (var j = 0; j < oldColNames.length; j++)
		{
			if (newColNames[i] == oldColNames[j])
			{
				remap[i] = j;
			}
		}
	}
	return remap;
}

/***
* Save a grid colModel to the database
* 
* @param gridId
* @param oldColModel
* @param {Array} remap
*/
function SaveColModel(gridId, oldColModel, remap)
{
	var model = CopyObject($(gridId).jqGrid ("getGridParam", "colModel"));
//	var newColModel = JSON.stringify(model);
//	if (JSON.stringify(oldColModel) != JSON.stringify(model))
	{
		var record = {};
		if (undefined === remap || null === remap)
		{
			// no remap passed in, generate a 'null' remap, i.e.
			// map column 0 to position 0, column 1 to position 1, etc.
			remap = [];
			for (var i = 0; i < model.length; i++)
				remap[i] = i;
		}
		var found = false;
		for (var i = 0; i < model.length; i++)
		{
			if (model[i].name == "Action")
			{
				found = true;
				break;
			}
		}
		if (!found)
		{
			// this is a sub grid, which doesn't have an action column.
			// need to add the action column so it will work for the main grid
			model.splice(0, 0, {"name":"Action","index":"Action","sortable":false,"align":"center","frozen":true,"firstsortorder":"desc","width":50,"title":true,"hidden":false,"widthOrg":50,"resizable":true});
			remap.splice(0, 0, 0);
			for (var i = 1; i < remap.length; i++)
			{
				++remap[i];
			}
		}
		record.remap = remap;
		record.colModel = model;
		$.ajax(
		{
			type: "POST",
			url: "/jqGridColModelConfig.php",
			data: "action=set&&value=" + encodeURIComponent(JSON.stringify(record)) + "&name=" + $(gridId).attr("viewname") + "&component=Spectrum",
			success: function() {
				$(document).find('.tablegrid').each(function(){
					if ($(this).attr('Id').localeCompare($(gridId).attr('Id')) != 0)
					{
						// all other grids that use this view need to be remapped, which is done in the tabsactivate event
						if ($(this).attr('viewname').localeCompare($(gridId).attr('viewname')) == 0)
						{
							$(this).data('columnsAreRemapped', false);
						}
					}
				});
			}
		});
	}
}

var viewName;
function RemapGrid(gridId)
{
	if ($(gridId).data('columnsAreRemapped') != true)
	{
		viewName = $(gridId).attr("viewname");
		if (undefined !== viewName && viewName != '')
		$.ajax(
		{
			type: "POST",
			url: "/jqGridColModelConfig.php",
			data: "action=get&name=" + viewName + "&component=Spectrum",
			success: function(msg)
			{
				msg = msg.trim();
				var savedColModel = JSON.parse(msg);
				if (isset(savedColModel.colModel) && isset(savedColModel.remap))
				{
					// make sure the colModel length is the same as the number of
					// columns in this grid. A grid displayed on the main tab has more columns
					// than a subgrid. This is because main grids have an Action column, and
					// subgrids do not.
					var thisColModel = $(gridId).jqGrid('getGridParam', 'colModel');
					if (savedColModel.colModel.length != thisColModel.length)
					{
						for (var i = 0; i < savedColModel.colModel.length; i++)
						{
							// for each column in the savedColModel, make sure that it
							// exists in thisColModel. If not, remove the column from
							// thisColModel
							var found = false;
							for (var j = 0; j < thisColModel.length; j++)
							{
								if (thisColModel[j].name == savedColModel.colModel[i].name)
								{
									found = true;
									break;
								}
							}
							if (!found)
							{
								savedColModel.remap.splice(i, 1);
								savedColModel.colModel.splice(i, 1);
								for (var k = i; k < savedColModel.remap.length; k++)
								{
									--savedColModel.remap[k];
								}
								--i;
							}
						}
						for (i = 0; i < savedColModel.colModel.length; i++)
						{
							if (savedColModel.colModel[i].hidden)
							{
								$(gridId).jqGrid('hideCol',[thisColModel[i].name]);
							}
							else
							{
								$(gridId).jqGrid('showCol',[thisColModel[i].name]);
							}
						}
					}
					$(gridId).jqGrid('remapColumns', savedColModel.remap, true);
					$(gridId).data('columnsAreRemapped', true);
				}
			},
			error: function(jqXHR, textStatus, errorThrown)
			{
				console.debug('RemapGrid error: ' + textStatus);
			}
		});
	}
}

/**
 * Get a jqgrid's filter settings
 * @param gridId The html id of the jqGrid
 * @param table The sql table
 * @param column The sql column
 */
function GetFilterInformationFromGrid(gridId, table, column)
{
	var gridSearchParms = $('#' + gridId + ' .ui-jqgrid-btable').first().data();
	var filterTable = "";
	// var filterOperator = "";
	var filterValue = "";
	var filterColumn = "";
	var ret = "";
	for ( var key in gridSearchParms)
	{
		var obj = gridSearchParms[key];
		for ( var prop in obj)
		{
			if ('TableName' === prop)
			{
				filterTable = obj[prop];
			}
			if ('FieldName' === prop)
			{
				filterColumn = obj[prop];
			}
			if ('Operator' === prop)
			{
				filterOperator = obj[prop];
			}
			if ('Value' === prop)
			{
				filterValue = obj[prop];
			}
		}
		if ((table === filterTable) && (column === filterColumn))
		{
			ret = filterValue;
			break;
		}
	}
	return ret;
}
/**
 * Submit the PALOperationsNode. 
 * Called by the operations queue
 * @param URL The post location to send the operations node
 */
function submitGridNode(URL)
{
	var data = jsPAL.PALOperationsNode.Parms;
	// OpParms may contain RFC or ESig data that needs to be appended to the
	// delete request
	for ( var i = 0; i < OpParms.length; i++)
	{
		data += '&' + OpParms[i];
	}

	++PendingOperationRequests;
	Ajax(
	{
		type : 'POST',
		url : URL,
		data : data,
		success : function(msg)
		{
			--PendingOperationRequests;
			var response = ParseJson(msg);
			if (response)
				CheckOperationStatus(jsPAL.PALOperationsNode, response);
		},
		error : function(jqXHR, textStatus, errorThrown)
		{
			--PendingOperationRequests;
			OperationQueue.Clear();
			var errortext = textStatus;
			if (undefined !== errorThrown)
			{
				errortext += ' - ' + errorThrown;
			}
			alert("Error processing JSON reply:\n" + errortext);
		}

	});
}
/**
 * dummy node functions for PALOperationsNode
 */
function submitGridNodeSave(URL)
{
}
/**
 * dummy node functions for PALOperationsNode
 */
function submitGridNodeUpdate(URL)
{
}
/**
 * dummy node functions for PALOperationsNode
 */
function submitGridNodeReset(URL)
{
}
// TODO: JM Rework this and get out of global scope
/**
 * isInitializedDialog checks that a jQuery .dialog() has been called previously 
 * @param jQWidgetId The value of the DIV id containing the dialog widget  
*/
function isInitializedDialog(jQWidgetId)
{
	return ($('#' + jQWidgetId).dialog( "isOpen" ) === true);
//	return ($('#' + jQWidgetId).is(':data(dialog)'));
}
// Removes all of the error div tags from the search form
// Need to call this if search form is loading with  ajax
function eraseErrors()
{
	// remove all previous errors on the page
	var shortError = this.document.getElementById ('shortError');
	while (shortError !== null)
	{
		 shortError.parentNode.removeChild(shortError);
		 shortError = this.document.getElementById ('shortError');
	} 		
}
